module.exports = {
	"swagger": "2.0",
	"info": {
		"version": "v1",
		"title": "NewformaApi"
	},
	"host": "huntington",
	"basePath": "/NewformaAPI",
	"schemes": [
		"http"
	],
	"paths": {
		"/companies": {
			"get": {
				"tags": [
					"Companies"
				],
				"operationId": "Companies_FilterCompanies",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "name",
						"in": "query",
						"description": "Name of the company",
						"required": false,
						"type": "string"
					},
					{
						"name": "source.sourcePrimaryKey",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "source.sourceDescriptor",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "lastModifiedUtc",
						"in": "query",
						"required": false,
						"type": "string",
						"format": "date-time"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/FilterResponseDto[CompanyReferenceDto]"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"post": {
				"tags": [
					"Companies"
				],
				"operationId": "Companies_Create",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "model",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/CompanyCreateRequestDto"
						}
					}
				],
				"responses": {
					"201": {
						"description": "Created",
						"schema": {
							"$ref": "#/definitions/CreateResponseDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"409": {
						"description": "Conflict"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/companies/{companyId}": {
			"get": {
				"tags": [
					"Companies"
				],
				"operationId": "Companies_GetCompanyById",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "companyId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/CompanyDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"put": {
				"tags": [
					"Companies"
				],
				"operationId": "Companies_Update",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "companyId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "model",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/CompanyUpdateRequestDto"
						}
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"409": {
						"description": "Conflict"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"delete": {
				"tags": [
					"Companies"
				],
				"operationId": "Companies_Delete",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "companyId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/companies/{companyId}/officelocations": {
			"get": {
				"tags": [
					"CompanyOfficeLocations"
				],
				"operationId": "CompanyOfficeLocations_GetByFilter",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "companyId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "name",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "source.sourcePrimaryKey",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "source.sourceDescriptor",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "lastModifiedUtc",
						"in": "query",
						"required": false,
						"type": "string",
						"format": "date-time"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/FilterResponseDto[OfficeLocationReferenceDto]"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"post": {
				"tags": [
					"CompanyOfficeLocations"
				],
				"operationId": "CompanyOfficeLocations_Create",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "companyId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "model",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/OfficeLocationCreateRequestDto"
						}
					}
				],
				"responses": {
					"201": {
						"description": "Created",
						"schema": {
							"$ref": "#/definitions/CreateResponseDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/companies/{companyId}/officelocations/{officeLocationId}": {
			"get": {
				"tags": [
					"CompanyOfficeLocations"
				],
				"operationId": "CompanyOfficeLocations_GetById",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "companyId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "officeLocationId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/OfficeLocationDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"put": {
				"tags": [
					"CompanyOfficeLocations"
				],
				"operationId": "CompanyOfficeLocations_Update",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "companyId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "officeLocationId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "model",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/OfficeLocationUpdateRequestDto"
						}
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"delete": {
				"tags": [
					"CompanyOfficeLocations"
				],
				"operationId": "CompanyOfficeLocations_Delete",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "companyId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "officeLocationId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/contacts": {
			"get": {
				"tags": [
					"Contacts"
				],
				"operationId": "Contacts_FilterContacts",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "emailAddress",
						"in": "query",
						"description": "Must match typical email address form",
						"required": false,
						"type": "string"
					},
					{
						"name": "source.sourcePrimaryKey",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "source.sourceDescriptor",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "lastModifiedUtc",
						"in": "query",
						"required": false,
						"type": "string",
						"format": "date-time"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/FilterResponseDto[ContactReferenceDto]"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"post": {
				"tags": [
					"Contacts"
				],
				"operationId": "Contacts_Create",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "model",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/ContactCreateRequestDto"
						}
					}
				],
				"responses": {
					"201": {
						"description": "Created",
						"schema": {
							"$ref": "#/definitions/CreateResponseDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"409": {
						"description": "Conflict"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/contacts/{contactId}": {
			"get": {
				"tags": [
					"Contacts"
				],
				"operationId": "Contacts_GetContactById",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "contactId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/ContactDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"put": {
				"tags": [
					"Contacts"
				],
				"operationId": "Contacts_Update",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "contactId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "model",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/ContactUpdateRequestDto"
						}
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"409": {
						"description": "Conflict"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"delete": {
				"tags": [
					"Contacts"
				],
				"operationId": "Contacts_Delete",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "contactId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/edmsPlugins": {
			"get": {
				"tags": [
					"EdmsPlugins"
				],
				"operationId": "EdmsPlugins_Get",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/EdmsPluginsResponseDto"
						}
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/health": {
			"get": {
				"tags": [
					"Health"
				],
				"operationId": "Health_GetHealth",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"responses": {
					"200": {
						"description": "Result code telling you whether or not the system is healthy."
					}
				}
			}
		},
		"/projects/{projectId}/keywordlistassignments/{listAssignmentType}": {
			"get": {
				"tags": [
					"KeywordListAssignments"
				],
				"summary": "Gets the keyword list name for the specified type assigned to the specified project.",
				"operationId": "KeywordListAssignments_GetByType",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "listAssignmentType",
						"in": "path",
						"description": "Specifies the keyword list. Use snake_case, for example, uac_submittal_action_list",
						"required": true,
						"type": "string",
						"enum": [
							"action_item_discipline",
							"action_item_keywords",
							"action_item_status",
							"action_item_type",
							"addendum_action_list",
							"addendum_discipline_list",
							"addendum_keyword_list",
							"addendum_reasons_list",
							"addendum_types_list",
							"addendum_workflow_status",
							"asi_action_list",
							"asi_discipline_list",
							"asi_keyword_list",
							"asi_reasons_list",
							"asi_types_list",
							"asi_workflow_status",
							"bim_element_keywords",
							"bim_model_discipline",
							"bim_model_keywords",
							"bulletin_action_list",
							"bulletin_ccd_sum_type_list",
							"bulletin_cop_status_list",
							"bulletin_discipline_list",
							"bulletin_keyword_list",
							"bulletin_reasons_list",
							"bulletin_types_list",
							"bulletin_workflow_status",
							"ccd_action_list",
							"ccd_cop_status_list",
							"ccd_discipline_list",
							"ccd_keyword_list",
							"ccd_reasons_list",
							"ccd_sum_type_list",
							"ccd_workflow_status",
							"change_order_action_list",
							"change_order_discipline_list",
							"change_order_keyword_list",
							"change_order_proposal_action_list",
							"change_order_proposal_discipline_list",
							"change_order_proposal_keyword_list",
							"change_order_proposal_reasons_list",
							"change_order_proposal_workflow_status",
							"change_order_reasons_list",
							"change_order_workflow_status",
							"contract_action_list",
							"contract_discipline_list",
							"contract_keyword_list",
							"contract_terms_list",
							"contract_type_contractor_list",
							"contract_workflow_status",
							"daily_report_equipment_list",
							"daily_report_keyword_list",
							"daily_report_observations_category",
							"daily_report_status",
							"daily_report_subcontractor_discipline",
							"discussion_actions",
							"document_control_discipline",
							"document_control_keywords",
							"document_control_purposes",
							"document_control_scales",
							"document_control_sizes",
							"document_control_types",
							"document_set_keywords",
							"document_set_status",
							"event_keywords",
							"field_note_keyword_list",
							"markup_session_keywords",
							"markup_session_status",
							"markup_status_list",
							"model_view_keywords",
							"pco_keyword_list",
							"pco_reasons_list",
							"pco_status_list",
							"pco_types_list",
							"physical_transfer_methods",
							"priority_list",
							"project_email_keywords",
							"project_file_keywords",
							"proposal_request_action_list",
							"proposal_request_cop_status_list",
							"proposal_request_discipline_list",
							"proposal_request_keyword_list",
							"proposal_request_reasons_list",
							"proposal_request_workflow_status",
							"punch_list_disciplines",
							"punch_list_keywords",
							"punch_list_locations",
							"punch_list_purposes",
							"punch_list_spec_sections",
							"punch_list_status",
							"punch_list_types",
							"record_document_package_status",
							"record_document_revision_states",
							"record_document_status",
							"rfi_action_list",
							"rfi_discipline_list",
							"rfi_keyword_list",
							"rfi_reasons_list",
							"rfi_types_list",
							"rfi_workflow_status",
							"site_visit_keyword_list",
							"site_visit_observations_category",
							"site_visit_status_list",
							"site_visit_type",
							"sketch_discipline_list",
							"sketch_keyword_list",
							"sketch_reasons_list",
							"sketch_status_list",
							"sketch_types_list",
							"space_keywords",
							"submittal_action_list",
							"submittal_discipline_list",
							"submittal_keyword_list",
							"submittal_spec_section_list",
							"submittal_workflow_status",
							"transmittal_keywords",
							"transmittal_purposes"
						]
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/KeywordListAssignmentDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID, No assignment found with the specified list assignment type"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/keywordlists": {
			"get": {
				"tags": [
					"KeywordListAssignments"
				],
				"summary": "Gets the single/muliple keyword lists for the specified types assigned to the specified project",
				"operationId": "KeywordListAssignments_GetByKewordListType",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "type",
						"in": "query",
						"required": false,
						"type": "array",
						"items": {
							"type": "string",
							"enum": [
								"action_item_discipline",
								"action_item_keywords",
								"action_item_status",
								"action_item_type",
								"action_item_priority_list",
								"addendum_action_list",
								"addendum_discipline_list",
								"addendum_keyword_list",
								"addendum_reasons_list",
								"addendum_types_list",
								"addendum_workflow_status",
								"asi_action_list",
								"asi_discipline_list",
								"asi_keyword_list",
								"asi_reasons_list",
								"asi_types_list",
								"asi_workflow_status",
								"bim_element_keywords",
								"bim_model_discipline",
								"bim_model_keywords",
								"bulletin_action_list",
								"bulletin_ccd_sum_type_list",
								"bulletin_cop_status_list",
								"bulletin_discipline_list",
								"bulletin_keyword_list",
								"bulletin_reasons_list",
								"bulletin_types_list",
								"bulletin_workflow_status",
								"ccd_action_list",
								"ccd_cop_status_list",
								"ccd_discipline_list",
								"ccd_keyword_list",
								"ccd_reasons_list",
								"ccd_sum_type_list",
								"ccd_workflow_status",
								"change_order_action_list",
								"change_order_discipline_list",
								"change_order_keyword_list",
								"change_order_reasons_list",
								"change_order_workflow_status",
								"change_order_proposal_action_list",
								"change_order_proposal_discipline_list",
								"change_order_proposal_keyword_list",
								"change_order_proposal_reasons_list",
								"change_order_proposal_workflow_status",
								"contract_action_list",
								"contract_discipline_list",
								"contract_keyword_list",
								"contract_terms_list",
								"contract_type_contractor_list",
								"contract_workflow_status",
								"daily_report_equipment_list",
								"daily_report_keyword_list",
								"daily_report_observations_category",
								"daily_report_status",
								"daily_report_subcontractor_discipline",
								"discussion_actions",
								"document_control_discipline",
								"document_control_keywords",
								"document_control_purposes",
								"document_control_scales",
								"document_control_sizes",
								"document_control_types",
								"record_document_package_status",
								"record_document_revision_states",
								"record_document_status",
								"document_set_keywords",
								"document_set_status",
								"event_keywords",
								"field_notes_keyword_list",
								"markup_session_keywords",
								"markup_session_status",
								"markup_status_list",
								"model_view_keywords",
								"pco_keyword_list",
								"pco_reasons_list",
								"pco_status_list",
								"pco_types_list",
								"physical_transfer_methods",
								"project_email_keywords",
								"project_file_keywords",
								"proposal_request_action_list",
								"proposal_request_cop_status_list",
								"proposal_request_discipline_list",
								"proposal_request_keyword_list",
								"proposal_request_reasons_list",
								"proposal_request_workflow_status",
								"punch_list_disciplines",
								"punch_list_keywords",
								"punch_list_locations",
								"punch_list_purposes",
								"punch_list_spec_sections",
								"punch_list_status",
								"punch_list_types",
								"rfi_action_list",
								"rfi_discipline_list",
								"rfi_keyword_list",
								"rfi_reasons_list",
								"rfi_types_list",
								"rfi_workflow_status",
								"site_visit_keyword_list",
								"site_visit_observations_category",
								"site_visit_status_list",
								"site_visit_type",
								"sketch_discipline_list",
								"sketch_keyword_list",
								"sketch_reasons_list",
								"sketch_status_list",
								"sketch_types_list",
								"space_keywords",
								"submittal_action_list",
								"submittal_discipline_list",
								"submittal_keyword_list",
								"submittal_spec_section_list",
								"submittal_workflow_status",
								"transmittal_keywords",
								"transmittal_purposes",
								"action_items",
								"addendums",
								"supplemental_instructions",
								"bim",
								"bulletins",
								"contruction_change_directives",
								"change_orders",
								"change_order_proposals",
								"contracts",
								"daily_reports",
								"document_control",
								"document_set",
								"markup_session",
								"markup_status",
								"potential_change_orders",
								"project",
								"proposal_requests",
								"punch_list",
								"rfis",
								"site_visits",
								"sketches_and_supplemental_drawings",
								"submittals",
								"transmittals",
								"field_notes"
							]
						},
						"collectionFormat": "multi"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/FilterResponseDto[KeywordListsResponseDto]"
						}
					},
					"400": {
						"description": "Cannot process the request",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "Unauthorized.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "No project found with the specified project ID",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal Server Error",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			}
		},
		"/keywordlists/{keywordListId}": {
			"get": {
				"tags": [
					"Keywords"
				],
				"summary": "Gets a specified keyword list.",
				"operationId": "Keywords_GetListById",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "keywordListId",
						"in": "path",
						"description": "Identifies the keyword list (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/KeywordListDto[String]"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No keyword list found with the specified keyword list ID, The requested page was not found (using offsetToken)"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/companyroles/{projectCompanyRoleId}": {
			"get": {
				"tags": [
					"ProjectCompanyRoles"
				],
				"operationId": "ProjectCompanyRoles_GetById",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectCompanyRoleId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/ProjectCompanyRoleDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"delete": {
				"tags": [
					"ProjectCompanyRoles"
				],
				"operationId": "ProjectCompanyRoles_Delete",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectCompanyRoleId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/companyroles": {
			"get": {
				"tags": [
					"ProjectCompanyRoles"
				],
				"operationId": "ProjectCompanyRoles_Get",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/ProjectCompanyRoleListResponse"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"post": {
				"tags": [
					"ProjectCompanyRoles"
				],
				"operationId": "ProjectCompanyRoles_Create",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "model",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/ProjectCompanyRoleCreateRequestDto"
						}
					}
				],
				"responses": {
					"201": {
						"description": "Created",
						"schema": {
							"$ref": "#/definitions/CreateResponseDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"409": {
						"description": "Conflict"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/folders": {
			"get": {
				"tags": [
					"ProjectFolders"
				],
				"operationId": "ProjectFolders_Get",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/ProjectFoldersResponseDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}": {
			"get": {
				"tags": [
					"Projects"
				],
				"operationId": "Projects_GetById",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/ProjectDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"put": {
				"tags": [
					"Projects"
				],
				"operationId": "Projects_Update",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "model",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/ProjectUpdateRequestDto"
						}
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"delete": {
				"tags": [
					"Projects"
				],
				"operationId": "Projects_Delete",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/serverName": {
			"get": {
				"tags": [
					"Projects"
				],
				"operationId": "Projects_GetServerName",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"type": "string"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects": {
			"get": {
				"tags": [
					"Projects"
				],
				"operationId": "Projects_GetByFilter",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "name",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "number",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "source.sourcePrimaryKey",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "source.sourceDescriptor",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "lastModifiedUtc",
						"in": "query",
						"required": false,
						"type": "string",
						"format": "date-time"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/FilterResponseDto[ProjectReferenceDto]"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"post": {
				"tags": [
					"Projects"
				],
				"operationId": "Projects_Create",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "model",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/ProjectCreateRequestDto"
						}
					}
				],
				"responses": {
					"201": {
						"description": "Created",
						"schema": {
							"$ref": "#/definitions/CreateResponseDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/settings": {
			"get": {
				"tags": [
					"Projects"
				],
				"summary": "Gets a list of project settings information for requested projectIds",
				"operationId": "Projects_GetProjectSettingById",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectIds",
						"in": "query",
						"required": true,
						"type": "array",
						"items": {
							"type": "string"
						},
						"collectionFormat": "multi"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/ProjectSettingsResponseDto"
						}
					},
					"400": {
						"description": "Cannot process the request because it is malformed or incorrect.",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "You are not licensed to use this feature. As the response you will receive an IIS error page",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "No project found with the specified project Id.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal Server Error. As the response you will receive an IIS error page",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			}
		},
		"/projects/{projectId}/teammembers": {
			"get": {
				"tags": [
					"ProjectTeamMembers"
				],
				"operationId": "ProjectTeamMembers_FilterProjectTeamMembers",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "source.sourcePrimaryKey",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "source.sourceDescriptor",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "lastModifiedUtc",
						"in": "query",
						"required": false,
						"type": "string",
						"format": "date-time"
					},
					{
						"name": "groupIds",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/FilterResponseDto[ProjectTeamMemberRefDto]"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"post": {
				"tags": [
					"ProjectTeamMembers"
				],
				"operationId": "ProjectTeamMembers_Create",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectTeamMemberCreateRequestDto",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/ProjectTeamMemberCreateRequestDto"
						}
					}
				],
				"responses": {
					"201": {
						"description": "Created",
						"schema": {
							"$ref": "#/definitions/CreateResponseDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"409": {
						"description": "Conflict"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/teammembers/{projectTeamMemberId}": {
			"get": {
				"tags": [
					"ProjectTeamMembers"
				],
				"operationId": "ProjectTeamMembers_GetProjectTeamMemberById",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectTeamMemberId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/ProjectTeamMemberDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"put": {
				"tags": [
					"ProjectTeamMembers"
				],
				"operationId": "ProjectTeamMembers_Update",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectTeamMemberId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectTeamMemberUpdateDto",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/ProjectTeamMemberUpdateRequestDto"
						}
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"delete": {
				"tags": [
					"ProjectTeamMembers"
				],
				"operationId": "ProjectTeamMembers_Delete",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "projectTeamMemberId",
						"in": "path",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/punchlistitems/{punchListItemId}": {
			"get": {
				"tags": [
					"PunchListItems"
				],
				"summary": "Gets detailed information about a Punch List Item.",
				"operationId": "PunchListItems_GetById",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "punchListItemId",
						"in": "path",
						"description": "Identifies the punch list item (GUID)",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/PunchListItemResponseDto"
						}
					},
					"400": {
						"description": "Cannot process the request because it is malformed or incorrect.",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "Cannot process the request because it is malformed or incorrect.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "{Parameter} not found: {parameter value}",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal Server Error. As the response you will receive an IIS error page",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			},
			"delete": {
				"tags": [
					"PunchListItems"
				],
				"summary": "Delete a punch list item by punchListItemId in a specific project",
				"operationId": "PunchListItems_Delete",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "punchListItemId",
						"in": "path",
						"description": "Identifies the punch list item (GUID)",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "Cannot process the request because it is malformed or incorrect.",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "You are not licensed to use this feature. As the response you will receive an IIS error page",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "No project found with the specified project Id.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal Server Error. As the response you will receive an IIS error page",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"400 #01": {
						"description": "The <span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>projectId</code></pre></div></div></span> field must be a valid GUID at url.",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"projectId": [
											"The 'projectId' field must be a valid GUID."
										]
									}
								}
							}
						}
					},
					"400 #02": {
						"description": "The <span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>punchListItemId</code></pre></div></div></span> field must be a valid GUID at url.",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"punchListItemId": [
											"The 'punchListItemId' field must be a valid GUID."
										]
									}
								}
							}
						}
					},
					"403 #01": {
						"description": "The user does not have a professional user role.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "The user does not have a professional user role."
								}
							}
						}
					},
					"403 #02": {
						"description": "Cannot delete punch list item in project. The project is in read only mode.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "Cannot delete punch list item in project. The project is in read only mode."
								}
							}
						}
					},
					"403 #03": {
						"description": "Cannot delete punch list item in project. Project settings restrict deleting items enabled.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "Cannot delete punch list item in project. Project settings restrict deleting items enabled."
								}
							}
						}
					},
					"404 #01": {
						"description": "The Item: <span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>projectId</code></pre></div></div></span> were not found.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "Project not found: 00000000-0000-0000-0000-000000000000."
								}
							}
						}
					},
					"404 #02": {
						"description": "The Item: <span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>punchListitem</code></pre></div></div></span> were not found.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "Item in project: 00000000-0000-0000-0000-000000000000 with Id: 00000000-0000-0000-0000-000000000000 was not found."
								}
							}
						}
					},
					"503 #01": {
						"description": "Unable to verify if this version of NewformaApi '1.0.0.0' is compatible with Newforma Project Center Server version '1.0.0.0', because the server is offline.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "The server is offline"
								}
							}
						}
					}
				}
			},
			"patch": {
				"tags": [
					"PunchListItems"
				],
				"summary": "Modify a single PunchList Item for the project.",
				"operationId": "PunchListItems_Update",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "punchListItemId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "model",
						"in": "body",
						"description": "Payload does not have the required minimum data. Endpoint allow to use any property.",
						"required": true,
						"schema": {
							"$ref": "#/definitions/ModifyPunchListItemDtoExample",
							"type": "ModifyPunchListItemDtoExample"
						}
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "Cannot process the request because it is malformed or incorrect.",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "You are not licensed to use this feature. As the response you will receive an IIS error page"
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "No project found with the specified project Id.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal Server Error. As the response you will receive an IIS error page"
					},
					"400 #01": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"spaceId\": \"\"\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"SpaceId.value": [
											"The 'spaceId' field must be a valid GUID."
										]
									}
								}
							}
						}
					},
					"400 #02": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"spaceId\": null\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"SpaceId.value": [
											"The 'spaceId' field is required."
										]
									}
								}
							}
						}
					},
					"400 #03": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"id\": \"\"\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"ID.value": [
											"The 'id' field is required."
										]
									}
								}
							}
						}
					},
					"400 #04": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"id\": null\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"ID.value": [
											"The 'id' field is required."
										]
									}
								}
							}
						}
					},
					"400 #05": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"type\": {\r\n    \"type\": \"generic\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"type": [
											"The 'name' property is required."
										]
									}
								}
							}
						}
					},
					"400 #06": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"type\": {\r\n    \"name\": \"Punch List\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"type": [
											"The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #07": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"type\": {}\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"type": [
											"The 'name' property is required. \n The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #08": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"location\": {\r\n    \"type\": \"generic\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"location": [
											"The 'name' property is required."
										]
									}
								}
							}
						}
					},
					"400 #09": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"location\": {\r\n    \"name\": \"Heather Ripley, Ripley PR, 865-977-1973\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"location": [
											"The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #10": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"location\": {}\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"location": [
											"The 'name' property is required. \n The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #11": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"location\": {\r\n    \"name\": \"Heather Ripley, Ripley PR, 865-977-1973\",\r\n    \"type\": \"wrong type\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"location": [
											"The 'type' property of keyword is not of type 'generic'."
										]
									}
								}
							}
						}
					},
					"400 #12": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"element\": null\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"Element.value": [
											"The 'element' field is required."
										]
									}
								}
							}
						}
					},
					"400 #13": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"element\": \"\"\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"Element.value": [
											"The 'element' field is required."
										]
									}
								}
							}
						}
					},
					"400 #14": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"element\": {\r\n    \"type\": \"generic\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"element": [
											"The 'name' property is required."
										]
									}
								}
							}
						}
					},
					"400 #15": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"element\": {\r\n    \"name\": \"desk office\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"element": [
											"The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #16": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"element\": {\r\n    \"name\": \"desk office\",\r\n    \"type\": \"wrong type\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"element": [
											"The 'type' property of keyword is not of type 'generic'."
										]
									}
								}
							}
						}
					},
					"400 #17": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"element\": {}\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"element": [
											"The 'name' property is required. \n The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #18": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"description\": null\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"Description.value": [
											"The 'description' field is required."
										]
									}
								}
							}
						}
					},
					"400 #19": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"description\": \"\"\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"Description.value": [
											"The 'description' field is required."
										]
									}
								}
							}
						}
					},
					"400 #20": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"description\": {\r\n    \"type\": \"generic\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"description": [
											"The 'name' property is required."
										]
									}
								}
							}
						}
					},
					"400 #21": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"description\": {\r\n    \"name\": \"pipe is leaking\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"description": [
											"The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #22": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"description\": {\r\n    \"name\": \"pipe is leaking\",\r\n    \"type\": \"wrong type\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"description": [
											"The 'type' property of keyword is not of type 'generic'."
										]
									}
								}
							}
						}
					},
					"400 #23": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"description\": {}\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"description": [
											"The 'name' property is required. \n The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #24": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"assignedTo\": [\r\n    \"00000000-0000-0000-0000-000000000000\",\r\n    \"invalid\"\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"AssignedTo.value[1]": [
											"The 'assignedTo' field must be a valid GUID."
										]
									}
								}
							}
						}
					},
					"400 #25": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"assignedTo\": [\r\n    \"\"\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"AssignedTo.value[0]": [
											"The 'assignedTo' field must be a valid GUID."
										]
									}
								}
							}
						}
					},
					"400 #26": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"assignedTo\": [\r\n    null\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"AssignedTo.value[0]": [
											"The 'assignedTo' field must be a valid GUID."
										]
									}
								}
							}
						}
					},
					"400 #27": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"assignedTo\": [\r\n    \"00000000-0000-0000-0000-000000000000\",\r\n    \"00000000-0000-0000-0000-000000000000\"\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"AssignedTo.value": [
											"Duplicate in 'assignedTo' found"
										]
									}
								}
							}
						}
					},
					"400 #28": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"members\": [\r\n    \"00000000-0000-0000-0000-000000000000\",\r\n    \"invalid\"\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"Members.value[1]": [
											"The 'members' field must be a valid GUID."
										]
									}
								}
							}
						}
					},
					"400 #29": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"members\": [\r\n    \"\"\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"Members.value[0]": [
											"The 'members' field must be a valid GUID."
										]
									}
								}
							}
						}
					},
					"400 #30": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"members\": [\r\n    null\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"Members.value[0]": [
											"The 'members' field must be a valid GUID."
										]
									}
								}
							}
						}
					},
					"400 #31": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"members\": [\r\n    \"00000000-0000-0000-0000-000000000000\",\r\n    \"00000000-0000-0000-0000-000000000000\"\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"Members.value": [
											"Duplicate in 'members' found"
										]
									}
								}
							}
						}
					},
					"400 #32": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"dueDate\": \"invalid date\"\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"DueDate.value": [
											"The 'dueDate' value is not in valid date format."
										]
									}
								}
							}
						}
					},
					"400 #33": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"date\": \"invalid date\"\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"Date.value": [
											"The 'date' value is not in valid date format."
										]
									}
								}
							}
						}
					},
					"400 #34": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"date\": \"\"\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"Date.value": [
											"The 'date' field is required."
										]
									}
								}
							}
						}
					},
					"400 #35": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"date\": null\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"Date.value": [
											"The 'date' field is required."
										]
									}
								}
							}
						}
					},
					"400 #36": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"specSection\": {\r\n    \"type\": \"generic\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"specSection": [
											"The 'name' property is required."
										]
									}
								}
							}
						}
					},
					"400 #37": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"specSection\": {\r\n    \"name\": \"pipe is leaking\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"specSection": [
											"The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #38": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"specSection\": {}\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"specSection": [
											"The 'name' property is required. \n The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #39": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"specSection\": {\r\n    \"name\": \"pipe is leaking\",\r\n    \"type\": \"wrong type\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"specSection": [
											"The 'type' property of keyword is not of type 'generic'."
										]
									}
								}
							}
						}
					},
					"400 #40": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"discipline\": {\r\n    \"type\": \"generic\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"discipline": [
											"The 'name' property is required."
										]
									}
								}
							}
						}
					},
					"400 #41": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"discipline\": {\r\n    \"name\": \"Plumbing\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"discipline": [
											"The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #42": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"discipline\": {}\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"discipline": [
											"The 'name' property is required. \n The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #43": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"discipline\": {\r\n    \"name\": \"Plumbing\",\r\n    \"type\": \"wrong type\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"discipline": [
											"The 'type' property of keyword is not of type 'generic'."
										]
									}
								}
							}
						}
					},
					"400 #44": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"purpose\": {\r\n    \"type\": \"generic\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"purpose": [
											"The 'name' property is required."
										]
									}
								}
							}
						}
					},
					"400 #45": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"purpose\": {\r\n    \"name\": \"because its broken\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"purpose": [
											"The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #46": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"purpose\": {}\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"purpose": [
											"The 'name' property is required. \n The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #47": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"purpose\": {\r\n    \"name\": \"because its broken\",\r\n    \"type\": \"wrong type\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"purpose": [
											"The 'type' property of keyword is not of type 'generic'."
										]
									}
								}
							}
						}
					},
					"400 #48": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"status\": {\r\n    \"type\": \"Draft\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"status": [
											"The 'name' property is required."
										]
									}
								}
							}
						}
					},
					"400 #49": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"status\": {\r\n    \"name\": \"Draft\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"status": [
											"The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #50": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"status\": {\r\n    \"name\": \"Draft\",\r\n    \"type\": \"Dra\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"status": [
											"The 'type' property must be set to 'draft', 'open', 'closed', or 'void'."
										]
									}
								}
							}
						}
					},
					"400 #51": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"status\": {}\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"status": [
											"The 'name' property is required. \n The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #52": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"status\": null\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"Status.value": [
											"The 'status' field is required."
										]
									}
								}
							}
						}
					},
					"400 #53": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"keywords\": [\r\n    {\r\n      \"name\": \"any keyword\"\r\n    }\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"keywords[0]": [
											"The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #54": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"keywords\": [\r\n    {\r\n      \"type\": \"generic\"\r\n    }\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"keywords[0]": [
											"The 'name' property is required."
										]
									}
								}
							}
						}
					},
					"400 #55": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"keywords\": [\r\n    {}\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"keywords[0]": [
											"The 'name' property is required. \n The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #56": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"keywords\": [\r\n    {\r\n      \"name\": \"any keyword with more than 255 characters....\",\r\n      \"type\": \"generic\"\r\n    }\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"keywords[0]": [
											"Exceeded maximum length of 255 characters for 'name' property."
										]
									}
								}
							}
						}
					},
					"400 #57": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"status\": {\r\n    \"name\": \"Draf\",\r\n    \"type\": \"Draft\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "Provided status is not supported."
								}
							}
						}
					},
					"403 #01": {
						"description": "The user does not have a professional user role.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "The user does not have a professional user role."
								}
							}
						}
					},
					"404 #01": {
						"description": "The Item: <span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>projectId</code></pre></div></div></span> were not found.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "Project not found: 00000000-0000-0000-0000-000000000000."
								}
							}
						}
					},
					"404 #02": {
						"description": "The Item: <span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>punchListItemId</code></pre></div></div></span> were not found.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "Item in project: 00000000-0000-0000-0000-000000000000 with Id: 00000000-0000-0000-0000-000000000000 was not found."
								}
							}
						}
					},
					"404 #03": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"spaceId\": \"00000000-0000-0000-0000-000000000000\"\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "RelatedItem for project item with id: 00000000-0000-0000-0000-000000000000 to PunchListItemSpace relation type was not found."
								}
							}
						}
					},
					"404 #04": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"assignedTo\": [\r\n    \"00000000-0000-0000-0000-000000000000\"\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "The 'assignedTo' contact GUID was not found: 00000000-0000-0000-0000-000000000000"
								}
							}
						}
					},
					"503 #01": {
						"description": "Unable to verify if this version of NewformaApi '1.0.0.0' is compatible with Newforma Project Center Server version '1.0.0.0', because the server is offline.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "The server is offline"
								}
							}
						}
					}
				}
			}
		},
		"/projects/{projectId}/punchlistitems": {
			"get": {
				"tags": [
					"PunchListItems"
				],
				"summary": "Gets a list of filtered Punch List items to be returned for a specific project",
				"operationId": "PunchListItems_GetByFilter",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "punchListItemId",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "id",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "spaceItem.spaceId",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "spaceItem.name",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "spaceItem.number",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "type.name",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "type.type",
						"in": "query",
						"required": false,
						"type": "string",
						"enum": [
							"generic"
						]
					},
					{
						"name": "discipline.name",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "discipline.type",
						"in": "query",
						"required": false,
						"type": "string",
						"enum": [
							"generic"
						]
					},
					{
						"name": "purpose.name",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "purpose.type",
						"in": "query",
						"required": false,
						"type": "string",
						"enum": [
							"generic"
						]
					},
					{
						"name": "status.name",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "status.type",
						"in": "query",
						"required": false,
						"type": "string",
						"enum": [
							"Draft",
							"Open",
							"Closed",
							"Void"
						]
					},
					{
						"name": "source.sourcePrimaryKey",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "source.sourceDescriptor",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "assignedTo",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "specSection.name",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "specSection.type",
						"in": "query",
						"required": false,
						"type": "string",
						"enum": [
							"generic"
						]
					},
					{
						"name": "lastAction.name",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "lastAction.type",
						"in": "query",
						"required": false,
						"type": "string",
						"enum": [
							"Completed",
							"Approved",
							"Rejected",
							"Comment"
						]
					},
					{
						"name": "lastModifiedDate",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/FilterResponseDto[PunchListItemsResponseDto]"
						}
					},
					"400": {
						"description": "Cannot process the request because it is malformed or incorrect.",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "Cannot process the request because it is malformed or incorrect.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "{Parameter} not found: {parameter value}",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal Server Error. As the response you will receive an IIS error page",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			},
			"post": {
				"tags": [
					"PunchListItems"
				],
				"summary": "Creates a Punch List Item within the specified project.",
				"operationId": "PunchListItems_Create",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "model",
						"in": "body",
						"description": "Example data in the model field is the minimum required data",
						"required": true,
						"schema": {
							"$ref": "#/definitions/CreatePunchListItemDto"
						},
						"default": "{\r\n  \"spaceId\": \"00000000-0000-0000-0000-000000000000\",\r\n  \"type\": {\r\n    \"name\": \"type\",\r\n    \"type\": \"generic\"\r\n  },\r\n  \"location\": {\r\n    \"name\": \"location\",\r\n    \"type\": \"generic\"\r\n  },\r\n  \"element\": {\r\n    \"name\": \"element\",\r\n    \"type\": \"generic\"\r\n  },\r\n  \"description\": {\r\n    \"name\": \"description\",\r\n    \"type\": \"generic\"\r\n  },\r\n  \"purpose\": {\r\n    \"name\": \"purpose\",\r\n    \"type\": \"generic\"\r\n  },\r\n  \"discipline\": {\r\n    \"name\": \"discipline\",\r\n    \"type\": \"generic\"\r\n  },\r\n  \"status\": {\r\n    \"name\": \"Draft\",\r\n    \"type\": \"Draft\"\r\n  },\r\n  \"date\": \"1989-11-25T07:53:00.123Z\"\r\n}"
					}
				],
				"responses": {
					"201": {
						"description": "Created",
						"schema": {
							"$ref": "#/definitions/CreateResponseDto"
						}
					},
					"400": {
						"description": "Cannot process the request because it is malformed or incorrect.",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "You are not licensed to use this feature. As the response you will receive an IIS error page"
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "No project found with the specified project Id.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"409": {
						"description": "A punchlist item with the same source already exists or a punchlist item with the same id already exists",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal Server Error. As the response you will receive an IIS error page"
					},
					"400 #01": {
						"description": "Minimal required request that includes:<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"status\": {\r\n    \"name\": \"open\",\r\n    \"type\": \"ope\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"status": [
											"The 'type' property must be set to 'draft', 'open', 'closed', or 'void'."
										]
									}
								}
							}
						}
					},
					"400 #02": {
						"description": "Minimal required request that includes:<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"capturedBy\": \"00000000-0000-0000-0000-000000000000\"\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"capturedBy": [
											"The 'capturedBy' field must be a valid GUID."
										]
									}
								}
							}
						}
					},
					"400 #03": {
						"description": "Minimal required request that includes:<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"members\": [\r\n    \"00000000-0000-0000-0000-000000000000\"\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"members[0]": [
											"The 'members[0]' element of array must be a valid GUID."
										]
									}
								}
							}
						}
					},
					"400 #04": {
						"description": "Minimal required request that includes:<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"assigneTo\": [\r\n    \"00000000-0000-0000-0000-000000000000\"\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"assigneTo[0]": [
											"The 'assigneTo[0]' element of array must be a valid GUID."
										]
									}
								}
							}
						}
					},
					"400 #05": {
						"description": "Minimal required request that includes:<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"spaceId\": \"00000000-0000-0000-0000-000000000000\"\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"spaceId": [
											"The 'spaceId' field must be a valid GUID."
										]
									}
								}
							}
						}
					},
					"400 #06": {
						"description": "Minimal required request without 'spaceId' or that includes:<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"spaceId\": null\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"spaceId": [
											"The 'spaceId' field is required."
										]
									}
								}
							}
						}
					},
					"400 #07": {
						"description": "Each project has options for whether or not to allow custom keywords and minimal required request. 'anyKeyword' may be - 'discipline' or 'location' or 'purpose' or 'specSection' or 'type' or 'status''<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"anyKeyword\": {\r\n    \"name\": \"custom name\",\r\n    \"type\": \"generic\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "'discipline' or 'location' or 'purpose' or 'specSection' or 'type' or 'status' does not allow custom values."
								}
							}
						}
					},
					"400 #08": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"keywords\": [\r\n    {\r\n      \"name\": \"any keyword\",\r\n      \"type\": \"custom generic\"\r\n    }\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"keywords[0]": [
											"The 'type' property of keyword is not of type 'generic'."
										],
										"keywords": [
											"The 'keywords' must be an array of 'generic' keywords."
										]
									}
								}
							}
						}
					},
					"400 #09": {
						"description": "The <span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>projectId</code></pre></div></div></span> field must be a valid GUID at url.",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"projectId": [
											"The 'projectId' field must be a valid GUID."
										]
									}
								}
							}
						}
					},
					"403 #01": {
						"description": "The user does not have a professional user role.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "The user does not have a professional user role."
								}
							}
						}
					},
					"404 #01": {
						"description": "The Item: <span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>projectId</code></pre></div></div></span> were not found.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "Project not found: 00000000-0000-0000-0000-000000000000."
								}
							}
						}
					},
					"404 #02": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"spaceId\": \"00000000-0000-0000-0000-000000000000\"\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "Space index item with GUID: 00000000-0000-0000-0000-000000000000 was not found in the project."
								}
							}
						}
					},
					"404 #03": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"assignedTo\": [\r\n    \"00000000-0000-0000-0000-000000000000\"\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "The 'assignedTo' contact GUID was not found: 00000000-0000-0000-0000-000000000000"
								}
							}
						}
					},
					"404 #04": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"members\": [\r\n    \"00000000-0000-0000-0000-000000000000\"\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "The 'members' contact GUID was not found: 00000000-0000-0000-0000-000000000000"
								}
							}
						}
					},
					"404 #05": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"capturedBy\": \"00000000-0000-0000-0000-000000000000\"\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "The 'capturedBy' contact GUID was not found: 00000000-0000-0000-0000-000000000000"
								}
							}
						}
					},
					"409 #01": {
						"description": "A punchlist item with the same source already exists.",
						"schema": {
							"properties": {
								"data": {
									"default": {
										"id": "00000000-0000-0000-0000-000000000000",
										"source": {
											"sourcePrimaryKey": "key",
											"sourceDescriptor": "desc"
										}
									}
								},
								"ErrorMessage": {
									"default": "The 'punchListItem' with 'id': 001 already exists."
								}
							}
						}
					},
					"409 #02": {
						"description": "A punchlist item with the same source already exists.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "Punchlist Item already exists"
								}
							}
						}
					},
					"503 #01": {
						"description": "Unable to verify if this version of NewformaApi '1.0.0.0' is compatible with Newforma Project Center Server version '1.0.0.0', because the server is offline.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "The server is offline"
								}
							}
						}
					}
				}
			}
		},
		"/projects/{projectId}/punchlistitems/{punchListItemId}/supportingDocuments": {
			"post": {
				"tags": [
					"PunchListItems"
				],
				"summary": "Add a supporting document(s) to an exsisting punch list item. It also creates a task to transfer file(s) from given URL to NPC",
				"operationId": "PunchListItems_AddSupportingDocument",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "punchListItemId",
						"in": "path",
						"description": "Identifies the punch list item (GUID) to which add supporting document(s)",
						"required": true,
						"type": "string"
					},
					{
						"name": "addSupportiveDocumentModel",
						"in": "body",
						"description": "The list of files to transfer from 3rd party to NPC",
						"required": true,
						"schema": {
							"$ref": "#/definitions/AddSupportingDocumentDto"
						}
					}
				],
				"responses": {
					"201": {
						"description": "Created",
						"schema": {
							"$ref": "#/definitions/CreateResponseDto"
						}
					},
					"400": {
						"description": "Cannot process the request because it is malformed or incorrect.",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "You are not licensed to use this feature. As the response you will receive an IIS error page",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "No project found with the specified project Id."
					},
					"409": {
						"description": "A punchlist item with the same source already exists or a punchlist item with the same id already exists",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal Server Error. As the response you will receive an IIS error page",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			}
		},
		"/projects/{projectId}/punchlistitems/{punchListItemId}/discussionitems": {
			"post": {
				"tags": [
					"PunchListItems"
				],
				"summary": "Creates a discussion item within the specified punch list item.",
				"operationId": "PunchListItems_CreateDiscussionItem",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "punchListItemId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "model",
						"in": "body",
						"description": "Example data in the model field is the minimum required data",
						"required": true,
						"schema": {
							"$ref": "#/definitions/CreateDiscussionItemDto"
						},
						"default": "{\r\n  \"date\": \"2022-10-10T10:09:08Z\",\r\n  \"action\": {\r\n    \"name\": \"Completed\",\r\n    \"type\": \"Completed\"\r\n  },\r\n  \"author\": \"94d37a15-95fc-41d3-aac2-4a1f29a8e442\"\r\n}"
					}
				],
				"responses": {
					"201": {
						"description": "Created",
						"schema": {
							"$ref": "#/definitions/CreateResponseDto"
						}
					},
					"400": {
						"description": "Cannot process the request because it is malformed or incorrect.",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "You are not licensed to use this feature. As the response you will receive an IIS error page"
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "No project found with the specified project Id.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal Server Error. As the response you will receive an IIS error page",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"400 #01": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"date\": null,\r\n  \"action\": null,\r\n  \"author\": null,\r\n  \"remarks\": null\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"date": [
											"The 'date' field is required."
										],
										"action": [
											"The 'action' field is required."
										],
										"author": [
											"The 'author' field is required."
										]
									}
								}
							}
						}
					},
					"400 #02": {
						"description": "Minimal required request that includes:<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"action\": {\r\n    \"type\": \"Completed\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"action": [
											"The 'name' property is required."
										]
									}
								}
							}
						}
					},
					"400 #03": {
						"description": "Minimal required request that includes:<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"action\": {\r\n    \"name\": \"Completed\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"action": [
											"The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #04": {
						"description": "Minimal required request that includes:<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"action\": {}\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"action": [
											"The 'name' property is required. \n The 'type' property is required."
										]
									}
								}
							}
						}
					},
					"400 #05": {
						"description": "Minimal required request that includes:<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"action\": {\r\n    \"name\": \"Completed\",\r\n    \"type\": \"Completed\"\r\n  }\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"action": [
											"The 'type' property must be set to 'draft', 'open', 'closed', or 'void'."
										]
									}
								}
							}
						}
					},
					"400 #06": {
						"description": "Minimal required request that includes:<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"remarks\": \"21846 or more characters........\"\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"errorMessage": {
									"default": "The request is invalid."
								},
								"modelState": {
									"default": {
										"remarks": [
											"Exceeded maximum length of 21845 characters for 'remarks' property."
										]
									}
								}
							}
						}
					},
					"403 #01": {
						"description": "The user does not have a professional user role.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "The user does not have a professional user role."
								}
							}
						}
					},
					"404 #01": {
						"description": "<span class=\"model-signature\"><div class=\"snippet\"><div class=\"snippet_json\"><pre style=\"margin-top:5px;padding:5px;\"><code>{\r\n  \"author\": [\r\n    \"00000000-0000-0000-0000-000000000000\"\r\n  ]\r\n}</code></pre></div></div></span>",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "The 'author' contact GUID was not found: 00000000-0000-0000-0000-000000000000"
								}
							}
						}
					},
					"503 #01": {
						"description": "Unable to verify if this version of NewformaApi '1.0.0.0' is compatible with Newforma Project Center Server version '1.0.0.0', because the server is offline.",
						"schema": {
							"properties": {
								"ErrorMessage": {
									"default": "The server is offline"
								}
							}
						}
					}
				}
			}
		},
		"/projects/{projectId}/recorddocuments/extendedproperties": {
			"get": {
				"tags": [
					"RecordDocuments"
				],
				"summary": "This endpoint responds with the list of user defined extended record document properties for the project.",
				"operationId": "RecordDocuments_GetRecordDocumentExtendedPropertiesList",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string",
						"format": "uuid"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/ExtendedPropertiesGroupDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/issueddocuments/{itemId}": {
			"get": {
				"tags": [
					"RecordDocuments"
				],
				"summary": "When the itemId is for a record document the record document and all of its issued revisions will be returned. When the itemId is for a record document revision the record document and only the associated revision will be returned.\r\nThe ContentFormat property is used to control which format (default = RTF,Text,HTML) the contents of the Description field is returned.",
				"operationId": "RecordDocuments_GetIssuedDocumentRevisions",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "itemId",
						"in": "path",
						"description": "When the itemId is for a record document the record document and all of its issued revisions will be returned. When the itemId is for a record document revision the record document and only the associated revision will be returned",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "contentFormatType",
						"in": "query",
						"description": "Identifies the desired format to return for formatted text fields. By default the text will be returned as it exists in the database.",
						"required": false,
						"type": "string",
						"enum": [
							"Default",
							"HTML",
							"RTF",
							"Text"
						]
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/RecordDocumentDetailsDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/issueddocuments/{recordDocumentId}/revisions/{recordDocumentRevisionId}": {
			"get": {
				"tags": [
					"RecordDocuments"
				],
				"summary": "This endpoint responds with the requested revision for an issued record document.\r\nThe ContentFormat property is used to control which format (default = RTF,Text,HTML) the contents of the Description field is returned.",
				"operationId": "RecordDocuments_GetSpecificIssuedDocumentRevision",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "recordDocumentId",
						"in": "path",
						"description": "Identifies the record document within this project (GUID)",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "recordDocumentRevisionId",
						"in": "path",
						"description": "Identifies the specific revision of the record document to return",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "contentFormatType",
						"in": "query",
						"description": "Identifies the desired format to return for formatted text fields. By default the text will be returned as it exists in the database.",
						"required": false,
						"type": "string",
						"enum": [
							"Default",
							"HTML",
							"RTF",
							"Text"
						]
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/RecordDocumentDetailsDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/issueddocuments": {
			"get": {
				"tags": [
					"RecordDocuments"
				],
				"summary": "This endpoint responds with the list of active issued record documents for the project and only returns the most recent revision for each document.\r\nIt is filterable by last modified date, and accepts a paging size.\r\nThe ContentFormat property is used to control which format (default = RTF,Text,HTML) the contents of the Description field is returned.",
				"operationId": "RecordDocuments_GeIssuedDocuments",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "lastModifiedUtc",
						"in": "query",
						"required": false,
						"type": "string",
						"format": "date-time"
					},
					{
						"name": "contentFormatType",
						"in": "query",
						"description": "This controls how the content of the Description field is returned.",
						"required": false,
						"type": "string",
						"enum": [
							"Default",
							"HTML",
							"RTF",
							"Text"
						]
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/FilterResponseDto[RecordDocumentDetailsDto]"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/rfis": {
			"get": {
				"tags": [
					"Rfis"
				],
				"summary": "Gets a list of project rfis.",
				"operationId": "Rfis_GetByFilter",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "name",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "projectItemNumber",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "status.name",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "status.type",
						"in": "query",
						"required": false,
						"type": "string",
						"enum": [
							"closed",
							"draft",
							"expected",
							"open",
							"pending"
						]
					},
					{
						"name": "source.sourcePrimaryKey",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "source.sourceDescriptor",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "lastModifiedUtc",
						"in": "query",
						"required": false,
						"type": "string",
						"format": "date-time"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/FilterResponseDto[RfiReferenceDto]"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID, The requested page was not found (using offsetToken)"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"post": {
				"tags": [
					"Rfis"
				],
				"summary": "Creates a pending or expected rfi within the specified project.",
				"operationId": "Rfis_Create",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "model",
						"in": "body",
						"description": "The rfi data",
						"required": true,
						"schema": {
							"$ref": "#/definitions/CreateRfiDto"
						}
					}
				],
				"responses": {
					"201": {
						"description": "Created",
						"schema": {
							"$ref": "#/definitions/CreateResponseDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID"
					},
					"409": {
						"description": "A rfi with the same source already exists"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/rfis/{rfiId}": {
			"get": {
				"tags": [
					"Rfis"
				],
				"summary": "Gets a specific project rfi",
				"operationId": "Rfis_GetById",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "rfiId",
						"in": "path",
						"description": "Identifies the rfi within this project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "contentFormatType",
						"in": "query",
						"description": "Identifies the desired format to return for formatted text fields. By default the text will be returned as it exists in the database.",
						"required": false,
						"type": "string",
						"enum": [
							"Default",
							"HTML",
							"RTF",
							"Text"
						]
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/RfiDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID, No Rfi found with the specified rfi ID"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/rfis/{rfiId}/reopen": {
			"put": {
				"tags": [
					"Rfis"
				],
				"summary": "Change the workflow status of a closed RFI to open",
				"operationId": "Rfis_PutReopenClosed",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "rfiId",
						"in": "path",
						"description": "Identifies the rfi within this project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "genericReopenDto",
						"in": "body",
						"description": "",
						"required": true,
						"schema": {
							"$ref": "#/definitions/GenericReopenDto"
						}
					}
				],
				"responses": {
					"200": {
						"description": "OK"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID, No Rfi found with the specified rfi ID, etc."
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/rfis/{rfiId}/external_workflows": {
			"post": {
				"tags": [
					"Rfis"
				],
				"summary": "Add an event to the RFI Change Log",
				"operationId": "Rfis_PostExternalWorkflows",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "rfiId",
						"in": "path",
						"description": "Identifies the rfi within this project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "model",
						"in": "body",
						"description": "valid values for event are 'delivered' or 'error'. A message must be provided",
						"required": true,
						"schema": {
							"$ref": "#/definitions/GenericExternalWorkflowDto"
						}
					}
				],
				"responses": {
					"200": {
						"description": "OK"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID, No Rfi found with the specified rfi ID, etc."
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/search": {
			"post": {
				"tags": [
					"Search"
				],
				"operationId": "Search_Get",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "requestDto",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/SearchRequestDto"
						}
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/PagedResponseDto[SearchResponseDto]"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "NotFound"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/spaces": {
			"get": {
				"tags": [
					"Spaces"
				],
				"summary": "This endpoint used to get list of spaces for the project",
				"operationId": "Spaces_GetByFilter",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project(GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "spaceId",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "name",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "number",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/FilterResponseDto[SpaceItemDto]"
						}
					},
					"400": {
						"description": "Cannot process the request because it is malformed or incorrect.",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "You are not licensed to use this feature. As the response you will receive an IIS error page",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "No project found with the specified project Id.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal Server Error. As the response you will receive an IIS error page",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			},
			"post": {
				"tags": [
					"Spaces"
				],
				"summary": "This endpoint used to create space for a project",
				"operationId": "Spaces_Create",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "model",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/CreateSpaceDto"
						}
					}
				],
				"responses": {
					"201": {
						"description": "Created",
						"schema": {
							"$ref": "#/definitions/CreateResponseDto"
						}
					},
					"400": {
						"description": "Cannot process the request because it is malformed or incorrect.",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "You are not licensed to use this feature. As the response you will receive an IIS error page",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "No project found with the specified project Id.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"409": {
						"description": "A space with the same source already exists",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal Server Error. As the response you will receive an IIS error page",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			}
		},
		"/projects/{projectId}/spaces/{spaceId}": {
			"delete": {
				"tags": [
					"Spaces"
				],
				"summary": "Deletes the existing space within the project",
				"operationId": "Spaces_Delete",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "spaceId",
						"in": "path",
						"description": "Identifies the space (GUID)",
						"required": true,
						"type": "string"
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "Cannot process the request",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "Unauthorized.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/ForbiddenException"
						}
					},
					"404": {
						"description": "Not found project ID or space ID",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal Server Error",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			},
			"patch": {
				"tags": [
					"Spaces"
				],
				"summary": "Modify the existing space related information for specified space associated with the project",
				"operationId": "Spaces_Update",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "spaceId",
						"in": "path",
						"required": true,
						"type": "string"
					},
					{
						"name": "model",
						"in": "body",
						"required": true,
						"schema": {
							"$ref": "#/definitions/ModifySpaceDto"
						}
					}
				],
				"responses": {
					"204": {
						"description": "NoContent"
					},
					"400": {
						"description": "Cannot process the request because it is malformed or incorrect.",
						"schema": {
							"$ref": "#/definitions/ValidationResultModel"
						}
					},
					"401": {
						"description": "You are not licensed to use this feature. As the response you will receive an IIS error page",
						"schema": {
							"type": "object"
						}
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"404": {
						"description": "No project found with the specified project Id.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					},
					"500": {
						"description": "Internal Server Error. As the response you will receive an IIS error page",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			}
		},
		"/projects/{projectId}/submittals": {
			"get": {
				"tags": [
					"Submittals"
				],
				"summary": "Gets a list of project submittals.",
				"operationId": "Submittals_GetByFilter",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "name",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "projectItemNumber",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "status.name",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "status.type",
						"in": "query",
						"required": false,
						"type": "string",
						"enum": [
							"closed",
							"draft",
							"expected",
							"open",
							"pending"
						]
					},
					{
						"name": "source.sourcePrimaryKey",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "source.sourceDescriptor",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "lastModifiedUtc",
						"in": "query",
						"required": false,
						"type": "string",
						"format": "date-time"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/FilterResponseDto[SubmittalReferenceDto]"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID, The requested page was not found (using offsetToken)"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			},
			"post": {
				"tags": [
					"Submittals"
				],
				"summary": "Creates a pending or expected submittal within the specified project.",
				"operationId": "Submittals_Create",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "model",
						"in": "body",
						"description": "The submittal data",
						"required": true,
						"schema": {
							"$ref": "#/definitions/CreateSubmittalDto"
						}
					}
				],
				"responses": {
					"201": {
						"description": "Created",
						"schema": {
							"$ref": "#/definitions/CreateResponseDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID"
					},
					"409": {
						"description": "A submittal with the same source already exists"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/submittals/{submittalId}": {
			"get": {
				"tags": [
					"Submittals"
				],
				"summary": "Gets a specific project submittal",
				"operationId": "Submittals_GetById",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "submittalId",
						"in": "path",
						"description": "Identifies the submittal within this project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "contentFormatType",
						"in": "query",
						"description": "Identifies the desired format to return for formatted text fields. By default the text will be returned as it exists in the database.",
						"required": false,
						"type": "string",
						"enum": [
							"Default",
							"HTML",
							"RTF",
							"Text"
						]
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/SubmittalDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID, No Submittal found with the specified submittal ID"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/submittals/{submittalId}/external_workflows": {
			"post": {
				"tags": [
					"Submittals"
				],
				"summary": "Add an event to the Submittal Change Log",
				"operationId": "Submittals_PostExternalWorkflows",
				"consumes": [
					"application/json",
					"text/json",
					"application/x-www-form-urlencoded"
				],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "Identifies the project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "submittalId",
						"in": "path",
						"description": "Identifies the submittal within this project (GUID)",
						"required": true,
						"type": "string"
					},
					{
						"name": "model",
						"in": "body",
						"description": "Valid values for event are 'delivered' or 'error'.  A message must be provided",
						"required": true,
						"schema": {
							"$ref": "#/definitions/GenericExternalWorkflowDto"
						}
					}
				],
				"responses": {
					"200": {
						"description": "OK"
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID, No Submittal found with the specified ID, etc."
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/transmittals/{transmittalId}": {
			"get": {
				"tags": [
					"Transmittals"
				],
				"summary": "Get by transmittalId is used to get the details about a given transmittal. This endpoint\r\ncan be used to gather the details of a given transmittal id that was returned by the\r\nGET /projects/{projectId}/submittals/{submittalId}.",
				"operationId": "Transmittals_GetById",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"description": "The Project ID, a GUID",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "transmittalId",
						"in": "path",
						"description": "The Transmittal ID, a GUID",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "contentFormatType",
						"in": "query",
						"description": "Identifies the desired format to return for formatted text fields. By default the text will be returned as it exists in the database.",
						"required": false,
						"type": "string",
						"enum": [
							"Default",
							"HTML",
							"RTF",
							"Text"
						]
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/TransmittalDetailsDto"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID, No transmittal found with the specified transmittal ID"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/projects/{projectId}/transmittals": {
			"get": {
				"tags": [
					"Transmittals"
				],
				"summary": "This endpoint provides the ability to retrieve a list of Transmittals for a project.\r\nIt provides the ability to optionally filter this list by last modified date and if\r\nthe transmittal was for issuing a record document.",
				"operationId": "Transmittals_GetByLastModifiedAndRelatedItem",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"parameters": [
					{
						"name": "projectId",
						"in": "path",
						"required": true,
						"type": "string",
						"format": "uuid"
					},
					{
						"name": "contentFormatType",
						"in": "query",
						"required": false,
						"type": "string",
						"enum": [
							"Default",
							"HTML",
							"RTF",
							"Text"
						]
					},
					{
						"name": "relatedItemTypeFilter",
						"in": "query",
						"required": false,
						"type": "string",
						"enum": [
							"ProjectItemToIssue"
						]
					},
					{
						"name": "lastModifiedUtc",
						"in": "query",
						"required": false,
						"type": "string",
						"format": "date-time"
					},
					{
						"name": "paging.offsetToken",
						"in": "query",
						"required": false,
						"type": "string"
					},
					{
						"name": "paging.maxSize",
						"in": "query",
						"required": false,
						"type": "integer",
						"format": "int32"
					}
				],
				"responses": {
					"200": {
						"description": "OK",
						"schema": {
							"$ref": "#/definitions/FilterResponseDto[TransmittalDetailsDto]"
						}
					},
					"400": {
						"description": "BadRequest"
					},
					"401": {
						"description": "Unauthorized"
					},
					"403": {
						"description": "Forbidden"
					},
					"404": {
						"description": "No project found with the specified project ID"
					},
					"500": {
						"description": "InternalServerError"
					}
				}
			}
		},
		"/me": {
			"get": {
				"tags": [
					"User"
				],
				"summary": "Retrieves contact information about the current Project Center user.",
				"operationId": "User_GetCurrentUser",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"responses": {
					"200": {
						"description": "The current user's NPC contact information.",
						"schema": {
							"$ref": "#/definitions/Contact"
						}
					},
					"403": {
						"description": "User is not licensed for Project Center.",
						"schema": {
							"$ref": "#/definitions/Error"
						}
					}
				}
			}
		},
		"/version": {
			"get": {
				"tags": [
					"Version"
				],
				"summary": "Gets version information about this server.",
				"operationId": "Version_GetVersionInfo",
				"consumes": [],
				"produces": [
					"application/json",
					"text/json"
				],
				"responses": {
					"200": {
						"description": "Version information",
						"schema": {
							"$ref": "#/definitions/NewformaVersionInfo"
						}
					},
					"404": {
						"description": "Installation is corrupt."
					}
				}
			}
		}
	},
	"definitions": {
		"CompanyFilterRequestDto": {
			"type": "object",
			"properties": {
				"name": {
					"description": "Name of the company",
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				},
				"lastModifiedUtc": {
					"format": "date-time",
					"type": "string"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				}
			}
		},
		"SourceInfoDto": {
			"required": [
				"sourcePrimaryKey",
				"sourceDescriptor"
			],
			"type": "object",
			"properties": {
				"sourcePrimaryKey": {
					"type": "string"
				},
				"sourceDescriptor": {
					"type": "string"
				}
			}
		},
		"PagingRequest": {
			"type": "object",
			"properties": {
				"offsetToken": {
					"type": "string"
				},
				"maxSize": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"FilterResponseDto[CompanyReferenceDto]": {
			"type": "object",
			"properties": {
				"items": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/CompanyReferenceDto"
					}
				},
				"offsetToken": {
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"CompanyReferenceDto": {
			"type": "object",
			"properties": {
				"id": {
					"description": "ID (typically a GUID) of the company",
					"type": "string"
				},
				"name": {
					"description": "Name of the company",
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"CompanyCreateRequestDto": {
			"required": [
				"name"
			],
			"type": "object",
			"properties": {
				"name": {
					"description": "Name of the company",
					"type": "string"
				},
				"mainContactId": {
					"description": "The main contact",
					"type": "string"
				},
				"disciplines": {
					"description": "List of disciplines associated with this company from the Global Discipline List, e.g., \"Architectural\", \"Electrical\"",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"specSections": {
					"description": "List of MasterFormat™ specification section numbers",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"companyType": {
					"description": "The type of company from the Global Company Type List, e.g., \"Architects\", \"Engineer\"",
					"type": "string"
				},
				"webUrl": {
					"description": "Web address of the company",
					"type": "string"
				},
				"notes": {
					"description": "Notes about the company (in HTML)",
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"CreateResponseDto": {
			"type": "object",
			"properties": {
				"id": {
					"description": "The identifier (typically a GUID) of the newly created entity",
					"type": "string"
				}
			}
		},
		"CompanyDto": {
			"required": [
				"id",
				"name"
			],
			"type": "object",
			"properties": {
				"id": {
					"description": "ID (typically a GUID) of the company",
					"type": "string"
				},
				"name": {
					"description": "Name of the company",
					"type": "string"
				},
				"mainContactId": {
					"description": "The main contact",
					"type": "string"
				},
				"disciplines": {
					"description": "List of disciplines associated with this company from the Global Discipline List, e.g., \"Architectural\", \"Electrical\"",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"specSections": {
					"description": "List of MasterFormat™ specification section numbers",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"companyType": {
					"description": "The type of company from the Global Company Type List, e.g., \"Architects\", \"Engineer\"",
					"type": "string"
				},
				"webUrl": {
					"description": "Web address of the company",
					"type": "string"
				},
				"notes": {
					"description": "Notes about the company (in HTML)",
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"CompanyUpdateRequestDto": {
			"required": [
				"name"
			],
			"type": "object",
			"properties": {
				"name": {
					"description": "Name of the company",
					"type": "string"
				},
				"mainContactId": {
					"description": "The main contact",
					"type": "string"
				},
				"disciplines": {
					"description": "List of disciplines associated with this company from the Global Discipline List, e.g., \"Architectural\", \"Electrical\"",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"specSections": {
					"description": "List of MasterFormat™ specification section numbers",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"companyType": {
					"description": "The type of company from the Global Company Type List, e.g., \"Architects\", \"Engineer\"",
					"type": "string"
				},
				"webUrl": {
					"description": "Web address of the company",
					"type": "string"
				},
				"notes": {
					"description": "Notes about the company (in HTML)",
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"OfficeLocationFilterRequestDto": {
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				},
				"lastModifiedUtc": {
					"format": "date-time",
					"type": "string"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				}
			}
		},
		"FilterResponseDto[OfficeLocationReferenceDto]": {
			"type": "object",
			"properties": {
				"items": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/OfficeLocationReferenceDto"
					}
				},
				"offsetToken": {
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"OfficeLocationReferenceDto": {
			"description": "Location associated with a company",
			"type": "object",
			"properties": {
				"id": {
					"description": "ID (typically a GUID) for the office location reference",
					"type": "string"
				},
				"name": {
					"description": "Name of this location",
					"type": "string"
				},
				"isPrimary": {
					"description": "Indicates whether or not this location is the default for this company. If true the existing primary office location will be set to false",
					"type": "boolean"
				},
				"address": {
					"$ref": "#/definitions/AddressDto",
					"description": "Mailing or geographical address"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"AddressDto": {
			"description": "Mailing or geographical address",
			"type": "object",
			"properties": {
				"addressType": {
					"description": "Type of the address from one of the values in the Global Address Types List, e.g., \"Mailing\", \"Office\", \"Job Site\"",
					"type": "string"
				},
				"street": {
					"description": "Street address, e.g., 123 Main St, Apt 2",
					"type": "string"
				},
				"city": {
					"description": "Name of city or town, e.g., New York City",
					"type": "string"
				},
				"state": {
					"description": "ISO 3166-2 code (or name) of the state/province/region or similar administrative subdivision, e.g., NY",
					"type": "string"
				},
				"zip": {
					"description": "Postal code (US is ZIP Code™ or ZIP+4 Code™)",
					"type": "string"
				},
				"country": {
					"description": "ISO 3166-1 alpha-2 code (or name) of the country, e.g., US",
					"type": "string"
				}
			}
		},
		"OfficeLocationCreateRequestDto": {
			"description": "Location associated with a company",
			"required": [
				"name"
			],
			"type": "object",
			"properties": {
				"name": {
					"description": "Name of this location. Must be unique and not null.",
					"type": "string"
				},
				"address": {
					"$ref": "#/definitions/AddressDto",
					"description": "Mailing or geographical address"
				},
				"phoneNumber": {
					"description": "Telephone number (canonical or free format)",
					"type": "string"
				},
				"faxNumber": {
					"description": "Fax number (canonical or free format)",
					"type": "string"
				},
				"isPrimary": {
					"description": "Indicates whether or not this location is the default for this company. If true the existing primary office location will be set to false",
					"type": "boolean"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"OfficeLocationDto": {
			"description": "Location associated with a company",
			"type": "object",
			"properties": {
				"id": {
					"description": "ID (typically a GUID) for the office location",
					"type": "string"
				},
				"isPrimary": {
					"description": "Indicates whether or not this location is the default for this company. If true the existing primary office location will be set to false",
					"type": "boolean"
				},
				"name": {
					"description": "Name of this location",
					"type": "string"
				},
				"phoneNumber": {
					"description": "Telephone number (canonical or free format)",
					"type": "string"
				},
				"faxNumber": {
					"description": "Fax number (canonical or free format)",
					"type": "string"
				},
				"address": {
					"$ref": "#/definitions/AddressDto",
					"description": "Mailing or geographical address"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"OfficeLocationUpdateRequestDto": {
			"required": [
				"name"
			],
			"type": "object",
			"properties": {
				"name": {
					"description": "Name of this location. Must be unique and not null.",
					"type": "string"
				},
				"address": {
					"$ref": "#/definitions/AddressDto",
					"description": "Mailing or geographical address"
				},
				"phoneNumber": {
					"description": "Telephone number (canonical or free format)",
					"type": "string"
				},
				"faxNumber": {
					"description": "Fax number (canonical or free format)",
					"type": "string"
				},
				"isPrimary": {
					"description": "Indicates whether or not this location is the default for this company. If true the existing primary office location will be set to false",
					"type": "boolean"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"ContactFilterRequestDto": {
			"description": "The contact filter should specify 0 or 1 filter terms",
			"type": "object",
			"properties": {
				"emailAddress": {
					"description": "Must match typical email address form",
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				},
				"lastModifiedUtc": {
					"format": "date-time",
					"type": "string"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				}
			}
		},
		"FilterResponseDto[ContactReferenceDto]": {
			"type": "object",
			"properties": {
				"items": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/ContactReferenceDto"
					}
				},
				"offsetToken": {
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"ContactReferenceDto": {
			"type": "object",
			"properties": {
				"id": {
					"description": "ID (typically a GUID)",
					"type": "string"
				},
				"firstName": {
					"description": "The name to appear first, the given name in most western cultures",
					"type": "string"
				},
				"lastName": {
					"description": "The name to appear last, the family name in most western cultures",
					"type": "string"
				},
				"emailAddress": {
					"description": "Must match typical email address form",
					"type": "string"
				},
				"isActive": {
					"description": "If false the user can not login into info exchange and will not show up in project teams",
					"type": "boolean"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"ContactCreateRequestDto": {
			"description": "A contact, typically a person",
			"type": "object",
			"properties": {
				"firstName": {
					"description": "The name to appear first, the given name in most western cultures",
					"type": "string"
				},
				"lastName": {
					"description": "The name to appear last, the family name in most western cultures",
					"type": "string"
				},
				"companyId": {
					"description": "The company ID (typically a GUID) that this user is affiliated with. ID must exist else a 400 (Bad Request) response will be returned.",
					"type": "string"
				},
				"emailAddress": {
					"description": "Must be NPC globally unique otherwise a 409 (Conflict) response will be returned.\r\nIf null, then firstName and/or lastName must be specified, otherwise must be formatted as an email address.",
					"type": "string"
				},
				"phoneNumberWork": {
					"description": "Telephone number (canonical or free format)",
					"type": "string"
				},
				"phoneNumberMobile": {
					"description": "Telephone number (canonical or free format)",
					"type": "string"
				},
				"phoneNumberHome": {
					"description": "Telephone number (canonical or free format)",
					"type": "string"
				},
				"faxNumber": {
					"description": "Fax number (canonical or free format)",
					"type": "string"
				},
				"disciplines": {
					"description": "List of disciplines associated with this contact from the Global Discipline List, e.g., \"Architectural\", \"Electrical\"",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"jobTitle": {
					"description": "The contact's job title (plain text), e.g., \"Project Manager\"",
					"type": "string"
				},
				"departmentName": {
					"description": "Name of the company department the contact is in (plain text), e.g., \"Accounting\"",
					"type": "string"
				},
				"notes": {
					"description": "Notes about this contact (in HTML)",
					"type": "string"
				},
				"culture": {
					"description": "The contact's preferred ISO 639-1 alpha-2 code language tag, e.g., \"en-US\". Must not be null. Must be a supported language, i.e., en, fr, de",
					"type": "string"
				},
				"address": {
					"$ref": "#/definitions/AddressDto",
					"description": "Mailing or geographical address"
				},
				"isActive": {
					"description": "If false the user cannot login into Info Exchange and will not show up in project teams",
					"type": "boolean"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"ContactDto": {
			"required": [
				"id"
			],
			"type": "object",
			"properties": {
				"id": {
					"description": "ID (typically a GUID) for the contact",
					"type": "string"
				},
				"firstName": {
					"description": "The name to appear first, the given name in most western cultures",
					"type": "string"
				},
				"lastName": {
					"description": "The name to appear last, the family name in most western cultures",
					"type": "string"
				},
				"companyId": {
					"description": "The company ID (typically a GUID) that this user is affiliated with. ID must exist else a 400 (Bad Request) response will be returned.",
					"type": "string"
				},
				"emailAddress": {
					"description": "Must be NPC globally unique otherwise a 409 (Conflict) response will be returned.\r\nIf null, then firstName and/or lastName must be specified, otherwise must be formatted as an email address.",
					"type": "string"
				},
				"phoneNumberWork": {
					"description": "Telephone number (canonical or free format)",
					"type": "string"
				},
				"phoneNumberMobile": {
					"description": "Telephone number (canonical or free format)",
					"type": "string"
				},
				"phoneNumberHome": {
					"description": "Telephone number (canonical or free format)",
					"type": "string"
				},
				"faxNumber": {
					"description": "Fax number (canonical or free format)",
					"type": "string"
				},
				"disciplines": {
					"description": "List of disciplines associated with this contact from the Global Discipline List, e.g., \"Architectural\", \"Electrical\"",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"jobTitle": {
					"description": "The contact's job title (plain text), e.g., \"Project Manager\"",
					"type": "string"
				},
				"departmentName": {
					"description": "Name of the company department the contact is in (plain text), e.g., \"Accounting\"",
					"type": "string"
				},
				"notes": {
					"description": "Notes about this contact (in HTML)",
					"type": "string"
				},
				"culture": {
					"description": "The contact's preferred ISO 639-1 alpha-2 code language tag, e.g., \"en-US\". Must not be null. Must be a supported language, i.e., en, fr, de",
					"type": "string"
				},
				"address": {
					"$ref": "#/definitions/AddressDto",
					"description": "Mailing or geographical address"
				},
				"isActive": {
					"description": "If false the user cannot login into Info Exchange and will not show up in project teams",
					"type": "boolean"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"ContactUpdateRequestDto": {
			"type": "object",
			"properties": {
				"firstName": {
					"description": "The name to appear first, the given name in most western cultures",
					"type": "string"
				},
				"lastName": {
					"description": "The name to appear last, the family name in most western cultures",
					"type": "string"
				},
				"companyId": {
					"description": "The company ID (typically a GUID) that this user is affiliated with. ID must exist else a 400 (Bad Request) response will be returned.",
					"type": "string"
				},
				"emailAddress": {
					"description": "Must be NPC globally unique otherwise a 409 (Conflict) response will be returned.\r\nIf null, then firstName and/or lastName must be specified, otherwise must be formatted as an email address.",
					"type": "string"
				},
				"phoneNumberWork": {
					"description": "Telephone number (canonical or free format)",
					"type": "string"
				},
				"phoneNumberMobile": {
					"description": "Telephone number (canonical or free format)",
					"type": "string"
				},
				"phoneNumberHome": {
					"description": "Telephone number (canonical or free format)",
					"type": "string"
				},
				"faxNumber": {
					"description": "Fax number (canonical or free format)",
					"type": "string"
				},
				"disciplines": {
					"description": "List of disciplines associated with this contact from the Global Discipline List, e.g., \"Architectural\", \"Electrical\"",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"jobTitle": {
					"description": "The contact's job title (plain text), e.g., \"Project Manager\"",
					"type": "string"
				},
				"departmentName": {
					"description": "Name of the company department the contact is in (plain text), e.g., \"Accounting\"",
					"type": "string"
				},
				"notes": {
					"description": "Notes about this contact (in HTML)",
					"type": "string"
				},
				"culture": {
					"description": "The contact's preferred ISO 639-1 alpha-2 code language tag, e.g., \"en-US\". Must not be null. Must be a supported language, i.e., en, fr, de",
					"type": "string"
				},
				"address": {
					"$ref": "#/definitions/AddressDto",
					"description": "Mailing or geographical address"
				},
				"isActive": {
					"description": "If false the user cannot login into Info Exchange and will not show up in project teams",
					"type": "boolean"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"EdmsPluginsResponseDto": {
			"type": "object",
			"properties": {
				"edmsPluginConfigs": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/EdmsPluginConfig"
					}
				}
			}
		},
		"EdmsPluginConfig": {
			"type": "object",
			"properties": {
				"id": {
					"type": "string"
				},
				"configName": {
					"type": "string"
				},
				"pluginName": {
					"type": "string"
				},
				"connectionString": {
					"type": "string"
				}
			}
		},
		"KeywordListAssignmentDto": {
			"type": "object",
			"properties": {
				"type": {
					"description": "Identifies the project property or project item property associated with a keyword list.\r\nThis corresponds to either the Project Center \"Project Settings\" dialog,\r\n\"Activity Center Setup\" tab, \"Define List Values\" section, \"Project Item Field\" column,\r\nor the \"Other Projects List\" tab, \"Project Item Field\".",
					"enum": [
						"action_item_discipline",
						"action_item_keywords",
						"action_item_status",
						"action_item_type",
						"addendum_action_list",
						"addendum_discipline_list",
						"addendum_keyword_list",
						"addendum_reasons_list",
						"addendum_types_list",
						"addendum_workflow_status",
						"asi_action_list",
						"asi_discipline_list",
						"asi_keyword_list",
						"asi_reasons_list",
						"asi_types_list",
						"asi_workflow_status",
						"bim_element_keywords",
						"bim_model_discipline",
						"bim_model_keywords",
						"bulletin_action_list",
						"bulletin_ccd_sum_type_list",
						"bulletin_cop_status_list",
						"bulletin_discipline_list",
						"bulletin_keyword_list",
						"bulletin_reasons_list",
						"bulletin_types_list",
						"bulletin_workflow_status",
						"ccd_action_list",
						"ccd_cop_status_list",
						"ccd_discipline_list",
						"ccd_keyword_list",
						"ccd_reasons_list",
						"ccd_sum_type_list",
						"ccd_workflow_status",
						"change_order_action_list",
						"change_order_discipline_list",
						"change_order_keyword_list",
						"change_order_proposal_action_list",
						"change_order_proposal_discipline_list",
						"change_order_proposal_keyword_list",
						"change_order_proposal_reasons_list",
						"change_order_proposal_workflow_status",
						"change_order_reasons_list",
						"change_order_workflow_status",
						"contract_action_list",
						"contract_discipline_list",
						"contract_keyword_list",
						"contract_terms_list",
						"contract_type_contractor_list",
						"contract_workflow_status",
						"daily_report_equipment_list",
						"daily_report_keyword_list",
						"daily_report_observations_category",
						"daily_report_status",
						"daily_report_subcontractor_discipline",
						"discussion_actions",
						"document_control_discipline",
						"document_control_keywords",
						"document_control_purposes",
						"document_control_scales",
						"document_control_sizes",
						"document_control_types",
						"document_set_keywords",
						"document_set_status",
						"event_keywords",
						"field_note_keyword_list",
						"markup_session_keywords",
						"markup_session_status",
						"markup_status_list",
						"model_view_keywords",
						"pco_keyword_list",
						"pco_reasons_list",
						"pco_status_list",
						"pco_types_list",
						"physical_transfer_methods",
						"priority_list",
						"project_email_keywords",
						"project_file_keywords",
						"proposal_request_action_list",
						"proposal_request_cop_status_list",
						"proposal_request_discipline_list",
						"proposal_request_keyword_list",
						"proposal_request_reasons_list",
						"proposal_request_workflow_status",
						"punch_list_disciplines",
						"punch_list_keywords",
						"punch_list_locations",
						"punch_list_purposes",
						"punch_list_spec_sections",
						"punch_list_status",
						"punch_list_types",
						"record_document_package_status",
						"record_document_revision_states",
						"record_document_status",
						"rfi_action_list",
						"rfi_discipline_list",
						"rfi_keyword_list",
						"rfi_reasons_list",
						"rfi_types_list",
						"rfi_workflow_status",
						"site_visit_keyword_list",
						"site_visit_observations_category",
						"site_visit_status_list",
						"site_visit_type",
						"sketch_discipline_list",
						"sketch_keyword_list",
						"sketch_reasons_list",
						"sketch_status_list",
						"sketch_types_list",
						"space_keywords",
						"submittal_action_list",
						"submittal_discipline_list",
						"submittal_keyword_list",
						"submittal_spec_section_list",
						"submittal_workflow_status",
						"transmittal_keywords",
						"transmittal_purposes"
					],
					"type": "string"
				},
				"keywordListId": {
					"description": "The ID of the specific keyword list associated with the project or project item property.",
					"type": "string"
				},
				"allowCustom": {
					"description": "Identifies whether or not keyword values are constrained to the values in the specified keyword list.",
					"type": "boolean"
				}
			}
		},
		"KeywordListsRequestDto": {
			"type": "object",
			"properties": {
				"type": {
					"type": "array",
					"items": {
						"enum": [
							"action_item_discipline",
							"action_item_keywords",
							"action_item_status",
							"action_item_type",
							"action_item_priority_list",
							"addendum_action_list",
							"addendum_discipline_list",
							"addendum_keyword_list",
							"addendum_reasons_list",
							"addendum_types_list",
							"addendum_workflow_status",
							"asi_action_list",
							"asi_discipline_list",
							"asi_keyword_list",
							"asi_reasons_list",
							"asi_types_list",
							"asi_workflow_status",
							"bim_element_keywords",
							"bim_model_discipline",
							"bim_model_keywords",
							"bulletin_action_list",
							"bulletin_ccd_sum_type_list",
							"bulletin_cop_status_list",
							"bulletin_discipline_list",
							"bulletin_keyword_list",
							"bulletin_reasons_list",
							"bulletin_types_list",
							"bulletin_workflow_status",
							"ccd_action_list",
							"ccd_cop_status_list",
							"ccd_discipline_list",
							"ccd_keyword_list",
							"ccd_reasons_list",
							"ccd_sum_type_list",
							"ccd_workflow_status",
							"change_order_action_list",
							"change_order_discipline_list",
							"change_order_keyword_list",
							"change_order_reasons_list",
							"change_order_workflow_status",
							"change_order_proposal_action_list",
							"change_order_proposal_discipline_list",
							"change_order_proposal_keyword_list",
							"change_order_proposal_reasons_list",
							"change_order_proposal_workflow_status",
							"contract_action_list",
							"contract_discipline_list",
							"contract_keyword_list",
							"contract_terms_list",
							"contract_type_contractor_list",
							"contract_workflow_status",
							"daily_report_equipment_list",
							"daily_report_keyword_list",
							"daily_report_observations_category",
							"daily_report_status",
							"daily_report_subcontractor_discipline",
							"discussion_actions",
							"document_control_discipline",
							"document_control_keywords",
							"document_control_purposes",
							"document_control_scales",
							"document_control_sizes",
							"document_control_types",
							"record_document_package_status",
							"record_document_revision_states",
							"record_document_status",
							"document_set_keywords",
							"document_set_status",
							"event_keywords",
							"field_notes_keyword_list",
							"markup_session_keywords",
							"markup_session_status",
							"markup_status_list",
							"model_view_keywords",
							"pco_keyword_list",
							"pco_reasons_list",
							"pco_status_list",
							"pco_types_list",
							"physical_transfer_methods",
							"project_email_keywords",
							"project_file_keywords",
							"proposal_request_action_list",
							"proposal_request_cop_status_list",
							"proposal_request_discipline_list",
							"proposal_request_keyword_list",
							"proposal_request_reasons_list",
							"proposal_request_workflow_status",
							"punch_list_disciplines",
							"punch_list_keywords",
							"punch_list_locations",
							"punch_list_purposes",
							"punch_list_spec_sections",
							"punch_list_status",
							"punch_list_types",
							"rfi_action_list",
							"rfi_discipline_list",
							"rfi_keyword_list",
							"rfi_reasons_list",
							"rfi_types_list",
							"rfi_workflow_status",
							"site_visit_keyword_list",
							"site_visit_observations_category",
							"site_visit_status_list",
							"site_visit_type",
							"sketch_discipline_list",
							"sketch_keyword_list",
							"sketch_reasons_list",
							"sketch_status_list",
							"sketch_types_list",
							"space_keywords",
							"submittal_action_list",
							"submittal_discipline_list",
							"submittal_keyword_list",
							"submittal_spec_section_list",
							"submittal_workflow_status",
							"transmittal_keywords",
							"transmittal_purposes",
							"action_items",
							"addendums",
							"supplemental_instructions",
							"bim",
							"bulletins",
							"contruction_change_directives",
							"change_orders",
							"change_order_proposals",
							"contracts",
							"daily_reports",
							"document_control",
							"document_set",
							"markup_session",
							"markup_status",
							"potential_change_orders",
							"project",
							"proposal_requests",
							"punch_list",
							"rfis",
							"site_visits",
							"sketches_and_supplemental_drawings",
							"submittals",
							"transmittals",
							"field_notes"
						],
						"type": "string"
					}
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				},
				"isFilterByType": {
					"type": "boolean",
					"readOnly": true
				}
			}
		},
		"FilterResponseDto[KeywordListsResponseDto]": {
			"type": "object",
			"properties": {
				"items": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordListsResponseDto"
					}
				},
				"offsetToken": {
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"KeywordListsResponseDto": {
			"type": "object",
			"properties": {
				"type": {
					"enum": [
						"action_item_discipline",
						"action_item_keywords",
						"action_item_status",
						"action_item_type",
						"action_item_priority_list",
						"addendum_action_list",
						"addendum_discipline_list",
						"addendum_keyword_list",
						"addendum_reasons_list",
						"addendum_types_list",
						"addendum_workflow_status",
						"asi_action_list",
						"asi_discipline_list",
						"asi_keyword_list",
						"asi_reasons_list",
						"asi_types_list",
						"asi_workflow_status",
						"bim_element_keywords",
						"bim_model_discipline",
						"bim_model_keywords",
						"bulletin_action_list",
						"bulletin_ccd_sum_type_list",
						"bulletin_cop_status_list",
						"bulletin_discipline_list",
						"bulletin_keyword_list",
						"bulletin_reasons_list",
						"bulletin_types_list",
						"bulletin_workflow_status",
						"ccd_action_list",
						"ccd_cop_status_list",
						"ccd_discipline_list",
						"ccd_keyword_list",
						"ccd_reasons_list",
						"ccd_sum_type_list",
						"ccd_workflow_status",
						"change_order_action_list",
						"change_order_discipline_list",
						"change_order_keyword_list",
						"change_order_reasons_list",
						"change_order_workflow_status",
						"change_order_proposal_action_list",
						"change_order_proposal_discipline_list",
						"change_order_proposal_keyword_list",
						"change_order_proposal_reasons_list",
						"change_order_proposal_workflow_status",
						"contract_action_list",
						"contract_discipline_list",
						"contract_keyword_list",
						"contract_terms_list",
						"contract_type_contractor_list",
						"contract_workflow_status",
						"daily_report_equipment_list",
						"daily_report_keyword_list",
						"daily_report_observations_category",
						"daily_report_status",
						"daily_report_subcontractor_discipline",
						"discussion_actions",
						"document_control_discipline",
						"document_control_keywords",
						"document_control_purposes",
						"document_control_scales",
						"document_control_sizes",
						"document_control_types",
						"record_document_package_status",
						"record_document_revision_states",
						"record_document_status",
						"document_set_keywords",
						"document_set_status",
						"event_keywords",
						"field_notes_keyword_list",
						"markup_session_keywords",
						"markup_session_status",
						"markup_status_list",
						"model_view_keywords",
						"pco_keyword_list",
						"pco_reasons_list",
						"pco_status_list",
						"pco_types_list",
						"physical_transfer_methods",
						"project_email_keywords",
						"project_file_keywords",
						"proposal_request_action_list",
						"proposal_request_cop_status_list",
						"proposal_request_discipline_list",
						"proposal_request_keyword_list",
						"proposal_request_reasons_list",
						"proposal_request_workflow_status",
						"punch_list_disciplines",
						"punch_list_keywords",
						"punch_list_locations",
						"punch_list_purposes",
						"punch_list_spec_sections",
						"punch_list_status",
						"punch_list_types",
						"rfi_action_list",
						"rfi_discipline_list",
						"rfi_keyword_list",
						"rfi_reasons_list",
						"rfi_types_list",
						"rfi_workflow_status",
						"site_visit_keyword_list",
						"site_visit_observations_category",
						"site_visit_status_list",
						"site_visit_type",
						"sketch_discipline_list",
						"sketch_keyword_list",
						"sketch_reasons_list",
						"sketch_status_list",
						"sketch_types_list",
						"space_keywords",
						"submittal_action_list",
						"submittal_discipline_list",
						"submittal_keyword_list",
						"submittal_spec_section_list",
						"submittal_workflow_status",
						"transmittal_keywords",
						"transmittal_purposes",
						"action_items",
						"addendums",
						"supplemental_instructions",
						"bim",
						"bulletins",
						"contruction_change_directives",
						"change_orders",
						"change_order_proposals",
						"contracts",
						"daily_reports",
						"document_control",
						"document_set",
						"markup_session",
						"markup_status",
						"potential_change_orders",
						"project",
						"proposal_requests",
						"punch_list",
						"rfis",
						"site_visits",
						"sketches_and_supplemental_drawings",
						"submittals",
						"transmittals",
						"field_notes"
					],
					"type": "string"
				},
				"keywordListId": {
					"type": "string"
				},
				"allowCustom": {
					"type": "boolean"
				},
				"lastModifiedUtc_ListAssignment": {
					"type": "string"
				},
				"lastModifiedUtc_KeywordList": {
					"type": "string"
				}
			}
		},
		"ValidationResultModel": {
			"type": "object",
			"properties": {
				"errorMessage": {
					"type": "string",
					"readOnly": true
				},
				"modelState": {
					"type": "object",
					"additionalProperties": {
						"type": "array",
						"items": {
							"type": "string"
						}
					},
					"readOnly": true
				}
			}
		},
		"Error": {
			"type": "object",
			"properties": {
				"ErrorMessage": {
					"description": "The error message in case of a failure.",
					"type": "string"
				}
			}
		},
		"KeywordListByIdFilterDto": {
			"type": "object",
			"properties": {
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				}
			}
		},
		"KeywordListDto[String]": {
			"type": "object",
			"properties": {
				"id": {
					"description": "The keyword list identifier",
					"type": "string"
				},
				"name": {
					"description": "The name of the keyword list.\r\nThis corresponds to the Project Center administration \"Keywords\" tab column named \"List Name\".",
					"type": "string"
				},
				"type": {
					"description": "The type of the keyword list.\r\nThis corresponds to the Project Center administration \"Keywords\" tab column named \"List Type\".",
					"enum": [
						"action_item_status",
						"action_item_type",
						"addendum_actions",
						"addendum_types",
						"address_types",
						"asi_actions",
						"asi_types",
						"auto_numbering_prefixes",
						"bulletin_actions",
						"bulletin_types",
						"ccd_actions",
						"ccd_sum_types",
						"change_order_actions",
						"change_order_proposal_actions",
						"company_role",
						"company_type",
						"contact_role",
						"contract_actions",
						"contract_status",
						"contract_terms",
						"contract_tunction",
						"contract_types",
						"contract_types_contractor",
						"cop_status",
						"daily_report_equipment",
						"daily_report_observations_category",
						"discipline",
						"discussion_actions",
						"document_control_types",
						"document_set_status",
						"email_tag_override",
						"form_letter_type",
						"keyword",
						"markup_session_status",
						"markup_status",
						"pco_status",
						"pco_types",
						"physical_transfer_methods",
						"priority",
						"project_phase",
						"project_status",
						"project_type",
						"proposal_request_actions",
						"punch_list_keywords",
						"punch_list_locations",
						"punch_list_purposes",
						"punch_list_status",
						"punch_list_types",
						"reasons",
						"record_document_package_status",
						"record_document_revision_states",
						"record_document_status",
						"report_status",
						"rfi_actions",
						"rfi_types",
						"scales",
						"site_visit_observations_category",
						"site_visit_status",
						"site_visit_type",
						"sizes",
						"sketch_status",
						"sketch_types",
						"spec_section",
						"submittal_actions",
						"transmittal_purposes",
						"workflow_status"
					],
					"type": "string"
				},
				"required": {
					"description": "Determines if the keyword list is required or not",
					"type": "boolean"
				},
				"items": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordListDefinitionDto[String]"
					}
				},
				"offsetToken": {
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"KeywordListDefinitionDto[String]": {
			"type": "object",
			"properties": {
				"name": {
					"description": "The name of the keyword.\r\nThis corresponds to the Project Center keyword list dialog's \"Name\" column.",
					"type": "string"
				},
				"type": {
					"description": "The type of the keyword.\r\nThis corresponds to the Project Center keyword list dialog's \"Type\" column.",
					"type": "string"
				},
				"description": {
					"description": "The description of the keyword.\r\nThis corresponds to the Project Center keyword list dialog's \"Description\" column.",
					"type": "string"
				},
				"displayOrder": {
					"format": "int32",
					"description": "The display order to use for sorting keywords",
					"type": "integer"
				}
			}
		},
		"ProjectCompanyRoleDto": {
			"type": "object",
			"properties": {
				"projectCompanyRoleId": {
					"type": "string"
				},
				"companyId": {
					"type": "string"
				},
				"role": {
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto"
				}
			}
		},
		"ProjectCompanyRoleListResponse": {
			"type": "object",
			"properties": {
				"projectCompanyRoles": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/ProjectCompanyRoleDto"
					}
				}
			}
		},
		"ProjectCompanyRoleCreateRequestDto": {
			"required": [
				"companyId",
				"role"
			],
			"type": "object",
			"properties": {
				"companyId": {
					"type": "string"
				},
				"role": {
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto"
				}
			}
		},
		"ProjectFoldersResponseDto": {
			"type": "object",
			"properties": {
				"projectId": {
					"format": "uuid",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"folders": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/ProjectFolderDto"
					}
				}
			}
		},
		"ProjectFolderDto": {
			"type": "object",
			"properties": {
				"folder": {
					"$ref": "#/definitions/EdmsObjectIdDto"
				},
				"folderKey": {
					"type": "string"
				},
				"isPrimary": {
					"type": "boolean"
				},
				"label": {
					"type": "string"
				}
			}
		},
		"EdmsObjectIdDto": {
			"type": "object",
			"properties": {
				"path": {
					"type": "string"
				},
				"pluginConfigId": {
					"type": "string"
				},
				"providerId": {
					"type": "string"
				}
			}
		},
		"ProjectDto": {
			"type": "object",
			"properties": {
				"description": {
					"description": "A description of the project in plain text",
					"type": "string"
				},
				"server": {
					"description": "The name of the Newforma Project Center Server (NPCS) hosting the project data and documents",
					"type": "string"
				},
				"status": {
					"description": "The project status; one of names in the Global Project Status List, e.g., \"Active\", \"Opportunity\"",
					"type": "string"
				},
				"type": {
					"description": "The type of project; one of the names in the Global Project Types keyword list, e.g., \"High Rise\", \"Industrial\", \"Stadium\", \"Education\"",
					"type": "string"
				},
				"address": {
					"$ref": "#/definitions/AddressBaseDto",
					"description": "The street address associated with the project"
				},
				"clientProjectNumber": {
					"description": "The client project number",
					"type": "string"
				},
				"mainContactId": {
					"description": "The main contact",
					"type": "string"
				},
				"managerId": {
					"description": "The project manager",
					"type": "string"
				},
				"principalInChargeId": {
					"description": "The principal in charge",
					"type": "string"
				},
				"id": {
					"format": "uuid",
					"description": "GUID of the project",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"name": {
					"description": "The project name",
					"type": "string"
				},
				"number": {
					"description": "The project number",
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"AddressBaseDto": {
			"description": "Mailing or geographical address",
			"type": "object",
			"properties": {
				"street": {
					"description": "Street address, e.g., 123 Main St, Apt 2",
					"type": "string"
				},
				"city": {
					"description": "Name of city or town, e.g., New York City",
					"type": "string"
				},
				"state": {
					"description": "ISO 3166-2 code (or name) of the state/province/region or similar administrative subdivision, e.g., NY",
					"type": "string"
				},
				"zip": {
					"description": "Postal code (US is ZIP Code™ or ZIP+4 Code™)",
					"type": "string"
				},
				"country": {
					"description": "ISO 3166-1 alpha-2 code (or name) of the country, e.g., US",
					"type": "string"
				}
			}
		},
		"ProjectUpdateRequestDto": {
			"required": [
				"status",
				"name"
			],
			"type": "object",
			"properties": {
				"status": {
					"description": "The project status; one of names in the Global Project Status List, e.g., \"Active\", \"Opportunity\"",
					"type": "string"
				},
				"name": {
					"description": "The project name",
					"type": "string"
				},
				"number": {
					"description": "The project number",
					"type": "string"
				},
				"description": {
					"description": "A description of the project in plain text",
					"type": "string"
				},
				"type": {
					"description": "The type of project; one of the names in the Global Project Types keyword list, e.g., \"High Rise\", \"Industrial\", \"Stadium\", \"Education\"",
					"type": "string"
				},
				"address": {
					"$ref": "#/definitions/AddressBaseDto"
				},
				"clientProjectNumber": {
					"description": "The client project number",
					"type": "string"
				},
				"mainContactId": {
					"description": "Contact id for main project contact",
					"type": "string"
				},
				"managerId": {
					"description": "Contact id for project manager",
					"type": "string"
				},
				"principalInChargeId": {
					"description": "Contact id for project principal in charge",
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"ProjectFilterRequestDto": {
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				},
				"lastModifiedUtc": {
					"format": "date-time",
					"type": "string"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				}
			}
		},
		"FilterResponseDto[ProjectReferenceDto]": {
			"type": "object",
			"properties": {
				"items": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/ProjectReferenceDto"
					}
				},
				"offsetToken": {
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"ProjectReferenceDto": {
			"type": "object",
			"properties": {
				"id": {
					"format": "uuid",
					"description": "GUID of the project",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"name": {
					"description": "The project name",
					"type": "string"
				},
				"number": {
					"description": "The project number",
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"ProjectCreateRequestDto": {
			"required": [
				"name",
				"templateProjectId",
				"server",
				"primaryProjectFolder"
			],
			"type": "object",
			"properties": {
				"name": {
					"description": "The project name",
					"type": "string"
				},
				"templateProjectId": {
					"description": "Creates the project from the template with the specified Id.",
					"type": "string"
				},
				"server": {
					"description": "The name of the Newforma Project Center Server (NPCS) hosting the project data and documents",
					"type": "string"
				},
				"primaryProjectFolder": {
					"$ref": "#/definitions/EdmsObjectIdDto"
				},
				"secondaryFolder": {
					"$ref": "#/definitions/EdmsObjectIdDto"
				},
				"status": {
					"description": "The project status; one of names in the Global Project Status List, e.g., \"Active\", \"Opportunity\"",
					"type": "string"
				},
				"number": {
					"description": "The project number",
					"type": "string"
				},
				"description": {
					"description": "A description of the project in plain text",
					"type": "string"
				},
				"type": {
					"description": "The type of project; one of the names in the Global Project Types keyword list, e.g., \"High Rise\", \"Industrial\", \"Stadium\", \"Education\"",
					"type": "string"
				},
				"address": {
					"$ref": "#/definitions/AddressBaseDto"
				},
				"clientProjectNumber": {
					"description": "The client project number",
					"type": "string"
				},
				"mainContactId": {
					"description": "Contact id for main project contact",
					"type": "string"
				},
				"managerId": {
					"description": "Contact id for project manager",
					"type": "string"
				},
				"principalInChargeId": {
					"description": "Contact id for project principal in charge",
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"ProjectSettingsFilterRequestDto": {
			"required": [
				"projectIds"
			],
			"type": "object",
			"properties": {
				"projectIds": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				}
			}
		},
		"FilterResponseDto[ProjectSettingsResponseDto]": {
			"type": "object",
			"properties": {
				"items": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/ProjectSettingsResponseDto"
					}
				},
				"offsetToken": {
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"ProjectSettingsResponseDto": {
			"type": "object",
			"properties": {
				"projectId": {
					"type": "string"
				},
				"name": {
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"lastModifiedDate": {
					"type": "string"
				},
				"settings": {
					"$ref": "#/definitions/ProjectSettingsDto"
				}
			}
		},
		"ProjectSettingsDto": {
			"type": "object",
			"properties": {
				"restrictDeletingItems": {
					"type": "boolean"
				},
				"availableOnNIXServer": {
					"type": "boolean"
				},
				"includeTransmittalInsteadOfEmailAttachment": {
					"type": "boolean"
				}
			}
		},
		"ProjectTeamMemberFilterDto": {
			"type": "object",
			"properties": {
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				},
				"lastModifiedUtc": {
					"format": "date-time",
					"type": "string"
				},
				"groupIds": {
					"type": "string"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				}
			}
		},
		"FilterResponseDto[ProjectTeamMemberRefDto]": {
			"type": "object",
			"properties": {
				"items": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/ProjectTeamMemberRefDto"
					}
				},
				"offsetToken": {
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"ProjectTeamMemberRefDto": {
			"type": "object",
			"properties": {
				"id": {
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				},
				"projectRef": {
					"$ref": "#/definitions/ProjectReferenceDto"
				},
				"contactRef": {
					"$ref": "#/definitions/ContactReferenceDto"
				}
			}
		},
		"ProjectTeamMemberCreateRequestDto": {
			"type": "object",
			"properties": {
				"contactId": {
					"type": "string"
				},
				"calculatePermissionSet": {
					"type": "boolean"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				},
				"permissionSetId": {
					"type": "string"
				}
			}
		},
		"ProjectTeamMemberDto": {
			"type": "object",
			"properties": {
				"permissionSetId": {
					"type": "string"
				},
				"groups": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/ProjectTeamGroupRefDto"
					}
				},
				"id": {
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				},
				"projectRef": {
					"$ref": "#/definitions/ProjectReferenceDto"
				},
				"contactRef": {
					"$ref": "#/definitions/ContactReferenceDto"
				}
			}
		},
		"ProjectTeamGroupRefDto": {
			"type": "object",
			"properties": {
				"id": {
					"type": "string"
				}
			}
		},
		"ProjectTeamMemberUpdateRequestDto": {
			"required": [
				"permissionSetId"
			],
			"type": "object",
			"properties": {
				"permissionSetId": {
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto",
					"description": "Identifies the source of the information (e.g., a third-party system) in Newforma. Blank if originated in Newforma."
				}
			}
		},
		"PunchListItemResponseDto": {
			"type": "object",
			"properties": {
				"punchListItemId": {
					"type": "string"
				},
				"id": {
					"type": "string"
				},
				"spaceItem": {
					"$ref": "#/definitions/PunchListItemSpaceItemResponseDto"
				},
				"element": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"location": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"description": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"assignedTo": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/PunchListItemContactResponseDto"
					}
				},
				"dueDate": {
					"type": "string"
				},
				"specSection": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"date": {
					"type": "string"
				},
				"members": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/PunchListItemContactResponseDto"
					}
				},
				"discipline": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"purpose": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[DBPunchlistItemStatus]"
				},
				"type": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"remarks": {
					"type": "string"
				},
				"keywords": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"capturedBy": {
					"$ref": "#/definitions/PunchListItemContactResponseDto"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto"
				},
				"lastModifiedDate": {
					"type": "string"
				},
				"createdDate": {
					"type": "string"
				},
				"discussionItems": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/PunchListItemDiscussionItemResponseDto"
					}
				},
				"supportingDocuments": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/SupportingDocumentsDto"
					}
				}
			}
		},
		"PunchListItemSpaceItemResponseDto": {
			"type": "object",
			"properties": {
				"spaceId": {
					"type": "string"
				},
				"name": {
					"type": "string"
				},
				"number": {
					"type": "string"
				}
			}
		},
		"KeywordDto[GenericKeyword]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"generic"
					],
					"type": "string"
				}
			}
		},
		"PunchListItemContactResponseDto": {
			"type": "object",
			"properties": {
				"contactId": {
					"type": "string"
				},
				"firstName": {
					"type": "string"
				},
				"lastName": {
					"type": "string"
				},
				"email": {
					"type": "string"
				}
			}
		},
		"KeywordDto[DBPunchlistItemStatus]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"Draft",
						"Open",
						"Closed",
						"Void"
					],
					"type": "string"
				}
			}
		},
		"PunchListItemDiscussionItemResponseDto": {
			"type": "object",
			"properties": {
				"discussionItemId": {
					"type": "string"
				},
				"action": {
					"$ref": "#/definitions/KeywordDto[DBDiscussionAction]"
				},
				"author": {
					"$ref": "#/definitions/PunchListItemContactResponseDto"
				},
				"remarks": {
					"type": "string"
				},
				"dateTime": {
					"type": "string"
				}
			}
		},
		"SupportingDocumentsDto": {
			"type": "object",
			"properties": {
				"file": {
					"$ref": "#/definitions/VersionedEdmsObjectIdDto"
				},
				"shared": {
					"type": "boolean"
				},
				"isTransferable": {
					"type": "boolean"
				}
			}
		},
		"KeywordDto[DBDiscussionAction]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"Completed",
						"Approved",
						"Rejected",
						"Comment"
					],
					"type": "string"
				}
			}
		},
		"VersionedEdmsObjectIdDto": {
			"type": "object",
			"properties": {
				"version": {
					"type": "string"
				},
				"path": {
					"type": "string"
				},
				"pluginConfigId": {
					"type": "string"
				},
				"providerId": {
					"type": "string"
				}
			}
		},
		"ModifyPunchListItemDto": {
			"type": "object",
			"properties": {
				"spaceId": {
					"$ref": "#/definitions/Option[String]"
				},
				"id": {
					"$ref": "#/definitions/Option[String]"
				},
				"type": {
					"$ref": "#/definitions/Option[KeywordDto[GenericKeyword]]"
				},
				"location": {
					"$ref": "#/definitions/Option[KeywordDto[GenericKeyword]]"
				},
				"element": {
					"$ref": "#/definitions/Option[KeywordDto[GenericKeyword]]"
				},
				"description": {
					"$ref": "#/definitions/Option[KeywordDto[GenericKeyword]]"
				},
				"assignedTo": {
					"$ref": "#/definitions/Option[String[]]"
				},
				"capturedBy": {
					"$ref": "#/definitions/Option[String]"
				},
				"members": {
					"$ref": "#/definitions/Option[String[]]"
				},
				"dueDate": {
					"$ref": "#/definitions/Option[String]"
				},
				"date": {
					"$ref": "#/definitions/Option[String]"
				},
				"specSection": {
					"$ref": "#/definitions/Option[KeywordDto[GenericKeyword]]"
				},
				"discipline": {
					"$ref": "#/definitions/Option[KeywordDto[GenericKeyword]]"
				},
				"purpose": {
					"$ref": "#/definitions/Option[KeywordDto[GenericKeyword]]"
				},
				"status": {
					"$ref": "#/definitions/Option[KeywordDto[PunchlistItemStatus]]"
				},
				"keywords": {
					"$ref": "#/definitions/Option[KeywordDto`1[]]"
				},
				"remarks": {
					"$ref": "#/definitions/Option[String]"
				}
			}
		},
		"SourceDetailDto": {
			"type": "object",
			"properties": {
				"sourcePrimaryKey": {
					"type": "string"
				},
				"sourceDescriptor": {
					"type": "string"
				}
			}
		},
		"Option[String]": {
			"type": "object",
			"properties": {
				"value": {
					"type": "string"
				}
			}
		},
		"Option[KeywordDto[GenericKeyword]]": {
			"type": "object",
			"properties": {
				"value": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				}
			}
		},
		"Option[String[]]": {
			"type": "object",
			"properties": {
				"value": {
					"type": "array",
					"items": {
						"type": "string"
					}
				}
			}
		},
		"Option[KeywordDto[PunchlistItemStatus]]": {
			"type": "object",
			"properties": {
				"value": {
					"$ref": "#/definitions/KeywordDto[PunchlistItemStatus]"
				}
			}
		},
		"Option[KeywordDto`1[]]": {
			"type": "object",
			"properties": {
				"value": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				}
			}
		},
		"KeywordDto[PunchlistItemStatus]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"Draft",
						"Open",
						"Closed",
						"Void"
					],
					"type": "string"
				}
			}
		},
		"CreatePunchListItemDto": {
			"required": [
				"spaceId",
				"type",
				"location",
				"element",
				"description",
				"date",
				"discipline",
				"purpose",
				"status"
			],
			"type": "object",
			"properties": {
				"spaceId": {
					"default": "00000000-0000-0000-0000-000000000000",
					"type": "string"
				},
				"id": {
					"default": "0001",
					"type": "string"
				},
				"type": {
					"default": {
						"name": "Punch List",
						"type": "generic"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"location": {
					"default": {
						"name": "Heather Ripley, Ripley PR, 865-977-1973",
						"type": "generic"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"element": {
					"default": {
						"name": "desk office",
						"type": "generic"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"description": {
					"default": {
						"name": "pipe is leaking",
						"type": "generic"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"assignedTo": {
					"default": [
						"00000000-0000-0000-0000-000000000000",
						"00000000-0000-0000-0000-000000000000"
					],
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"capturedBy": {
					"default": "00000000-0000-0000-0000-000000000000",
					"type": "string"
				},
				"members": {
					"default": [
						"00000000-0000-0000-0000-000000000000",
						"00000000-0000-0000-0000-000000000000"
					],
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"dueDate": {
					"default": "1989-11-25T07:53:00.123Z",
					"type": "string"
				},
				"date": {
					"default": "1989-11-25T07:53:00.123Z",
					"type": "string"
				},
				"specSection": {
					"default": {
						"name": "01 01 1001",
						"type": "generic"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"discipline": {
					"default": {
						"name": "Plumbing",
						"type": "generic"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"purpose": {
					"default": {
						"name": "because its broken",
						"type": "generic"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"status": {
					"default": {
						"name": "Open",
						"type": "Open"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"keywords": {
					"type": "array",
					"items": {
						"default": {
							"name": "I need new pipe",
							"type": "generic"
						},
						"type": "KeywordDto[GenericKeyword]"
					}
				},
				"remarks": {
					"default": "there was a pipe that broke",
					"type": "string"
				},
				"source": {
					"default": {
						"sourcePrimaryKey": "custom key 00000000-0000-0000-0000-000000000000",
						"sourceDescriptor": "custom descriptor 00000000-0000-0000-0000-000000000000"
					},
					"type": "SourceInfoDto"
				}
			}
		},
		"PunchListItemsFilterRequestDto": {
			"type": "object",
			"properties": {
				"punchListItemId": {
					"type": "string"
				},
				"id": {
					"type": "string"
				},
				"spaceItem": {
					"$ref": "#/definitions/PunchListItemsSpaceFilterRequestDto"
				},
				"type": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"discipline": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"purpose": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[DBPunchlistItemStatus]"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto"
				},
				"assignedTo": {
					"type": "string"
				},
				"specSection": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"lastAction": {
					"$ref": "#/definitions/KeywordDto[DBDiscussionAction]"
				},
				"lastModifiedDate": {
					"type": "string"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				}
			}
		},
		"PunchListItemsSpaceFilterRequestDto": {
			"type": "object",
			"properties": {
				"spaceId": {
					"type": "string"
				},
				"name": {
					"type": "string"
				},
				"number": {
					"type": "string"
				}
			}
		},
		"FilterResponseDto[PunchListItemsResponseDto]": {
			"type": "object",
			"properties": {
				"items": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/PunchListItemsResponseDto"
					}
				},
				"offsetToken": {
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"PunchListItemsResponseDto": {
			"type": "object",
			"properties": {
				"projectId": {
					"type": "string"
				},
				"punchListItemId": {
					"type": "string"
				},
				"id": {
					"type": "string"
				},
				"spaceItem": {
					"$ref": "#/definitions/PunchListItemsSpaceItemResponseDto"
				},
				"type": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"discipline": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"purpose": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[DBPunchlistItemStatus]"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto"
				},
				"assignedTo": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"specSection": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"lastAction": {
					"$ref": "#/definitions/KeywordDto[DBDiscussionAction]"
				},
				"hasSupportedDocuments": {
					"type": "boolean"
				}
			}
		},
		"PunchListItemsSpaceItemResponseDto": {
			"type": "object",
			"properties": {
				"spaceId": {
					"type": "string"
				},
				"name": {
					"type": "string"
				},
				"number": {
					"type": "string"
				}
			}
		},
		"AddSupportingDocumentDto": {
			"type": "object",
			"properties": {
				"files": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RemoteFileDto"
					}
				}
			}
		},
		"RemoteFileDto": {
			"required": [
				"url"
			],
			"type": "object",
			"properties": {
				"url": {
					"type": "string"
				},
				"name": {
					"type": "string"
				}
			}
		},
		"CreateDiscussionItemDto": {
			"required": [
				"date",
				"action",
				"author"
			],
			"type": "object",
			"properties": {
				"date": {
					"default": "1989-11-25T07:53:00.123Z",
					"type": "string"
				},
				"action": {
					"default": {
						"name": "Discussion about a pipe",
						"type": "Comment"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"author": {
					"default": "00000000-0000-0000-0000-000000000000",
					"type": "string"
				},
				"remarks": {
					"default": "there was a pipe that broke",
					"type": "string"
				}
			}
		},
		"ExtendedPropertiesGroupDto": {
			"type": "object",
			"properties": {
				"groupName": {
					"type": "string"
				},
				"properties": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/ExtendedPropertyDto"
					}
				}
			}
		},
		"ExtendedPropertyDto": {
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"defaultValue": {
					"type": "string"
				}
			}
		},
		"RecordDocumentDetailsDto": {
			"type": "object",
			"properties": {
				"id": {
					"description": "The specific information about the record doc being returned",
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"title": {
					"type": "string"
				},
				"disciplines": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"types": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"purpose": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[DBKeywordType]"
					}
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[DBRecordDocumentStatus]"
				},
				"description": {
					"type": "string"
				},
				"size": {
					"type": "string"
				},
				"scale": {
					"type": "string"
				},
				"lastModifiedUtc": {
					"format": "date-time",
					"type": "string"
				},
				"packages": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"extendedProperties": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/ExtendedPropertiesGroupDto"
					}
				},
				"revisions": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RecordDocumentRevisionDto"
					}
				}
			}
		},
		"KeywordDto[DBKeywordType]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"GenericKeyword",
						"PhysicalTransferMethod",
						"BasicTransmittalIncoming",
						"BasicTransmittalOutgoing",
						"DeprecatedSubmittalReceive",
						"DeprecatedSubmittalForward",
						"DeprecatedSubmittalReviewResponse",
						"DeprecatedSubmittalNoActionTaken",
						"DeprecatedSubmittalApprove",
						"DeprecatedSubmittalResubmit",
						"DeprecatedSubmittalReject",
						"DeprecatedRFIReceive",
						"DeprecatedRFIAssign",
						"DeprecatedRFIConsultantAnswer",
						"DeprecatedRFIConsultantNoAnswer",
						"DeprecatedRFIResponseNoImpact",
						"DeprecatedRFIResponsePotentialImpact",
						"DeprecatedRFIResponseHasImpact",
						"ProjectStatusOpportunity",
						"ProjectStatusActive",
						"ProjectStatusArchive",
						"ProjectStatusOffline",
						"ActionItemStatusOpen",
						"ActionItemStatusClosed",
						"ActionItemStatusDeferred",
						"ActionItemStatusActionComplete",
						"MarkupSessionStatusOpen",
						"MarkupSessionStatusClosed",
						"DocumentSetStatusActive",
						"DocumentSetStatusInactive",
						"AddressTypeMailing",
						"AddressTypeOffice",
						"AddressTypeJobSite",
						"WorkflowDraft",
						"WorkflowExpected",
						"WorkflowOpen",
						"WorkflowClosed",
						"WorkflowPending",
						"PunchListStatusOpen",
						"PunchListStatusClosed",
						"PunchListStatusDraft",
						"PunchListStatusVoid",
						"DiscussionActionCompleted",
						"DiscussionActionApproved",
						"DiscussionActionRejected",
						"DiscussionActionComment",
						"UDACReceive",
						"UDACForward",
						"UDACRecordResponse",
						"UDACSend",
						"UDACClose",
						"UDACReopen",
						"UDACSendAndClose",
						"UDACRespondAndCloseNoActionTaken",
						"UDACRespondAndCloseApprove",
						"UDACRespondAndCloseRejected",
						"UDACRespondAndCloseResubmit",
						"UDACFinalReceive",
						"RecordDocumentRevisionStateDraft",
						"RecordDocumentRevisionStateIssued",
						"ContractOpen",
						"ContractInactive",
						"SketchOpen",
						"SketchClosed",
						"RecordDocumentStatusActive",
						"RecordDocumentStatusInactive",
						"CompanyRoleLeadDesigner",
						"CompanyRoleClient",
						"CompanyRoleGeneralContractor",
						"CompanyRoleContractor",
						"CompanyRoleSubContractor",
						"CompanyRoleConsultant",
						"CompanyRoleAgency",
						"CompanyRoleVendor",
						"UDACFinalizableDraft",
						"UDACFinalizableFinal",
						"UDACSiteVisitSafety",
						"UDACSiteVisitQuality",
						"UDACSiteVisitDesign",
						"UDACSiteVisitOther",
						"UDACCost",
						"UDACBudget",
						"UDACPCOOpen",
						"UDACPCOPricingComplete",
						"UDACPCOClosed",
						"UDACPCOVoid",
						"UDACPCODraft",
						"UDACCloseApprove",
						"UDACSendAndCloseApprove",
						"UDACCloseNoActionTaken",
						"UDACCloseRejected",
						"RecordDocumentPackageStatusDraft",
						"RecordDocumentPackageStatusIssued"
					],
					"type": "string"
				}
			}
		},
		"KeywordDto[DBRecordDocumentStatus]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"Active",
						"Inactive"
					],
					"type": "string"
				}
			}
		},
		"RecordDocumentRevisionDto": {
			"type": "object",
			"properties": {
				"id": {
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"createdDateUtc": {
					"format": "date-time",
					"type": "string"
				},
				"description": {
					"type": "string"
				},
				"state": {
					"$ref": "#/definitions/KeywordDto[DBRecordDocumentRevisionState]"
				},
				"purpose": {
					"$ref": "#/definitions/KeywordDto[DBKeywordType]"
				},
				"transmittals": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/TransmittalSummaryDto"
					}
				},
				"revisionFile": {
					"$ref": "#/definitions/VersionedEdmsObjectIdDto"
				}
			}
		},
		"KeywordDto[DBRecordDocumentRevisionState]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"Issued",
						"NotIssued"
					],
					"type": "string"
				}
			}
		},
		"TransmittalSummaryDto": {
			"required": [
				"action",
				"creationDate",
				"dueDate",
				"via"
			],
			"type": "object",
			"properties": {
				"id": {
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"action": {
					"$ref": "#/definitions/KeywordDto[DBTransmittalActionType]",
					"description": "The specific information about the transmittal being returned"
				},
				"creationDate": {
					"format": "date",
					"description": "Transmittal date, no time included",
					"type": "string"
				},
				"dueDate": {
					"format": "date",
					"description": "The due date, no time included",
					"type": "string"
				},
				"via": {
					"$ref": "#/definitions/ViaDto",
					"description": "The via object describes how the transmittal was sent or received."
				},
				"relatedFiles": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RelatedFileDto"
					}
				}
			}
		},
		"KeywordDto[DBTransmittalActionType]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"BasicTransmittalIncoming",
						"BasicTransmittalOutgoing",
						"DeprecatedSubmittalReceive",
						"DeprecatedSubmittalForward",
						"DeprecatedSubmittalReviewResponse",
						"DeprecatedSubmittalNoActionTaken",
						"DeprecatedSubmittalApprove",
						"DeprecatedSubmittalResubmit",
						"DeprecatedSubmittalReject",
						"DeprecatedRFIReceive",
						"DeprecatedRFIAssign",
						"DeprecatedRFIConsultantAnswer",
						"DeprecatedRFIConsultantNoAnswer",
						"DeprecatedRFIResponseNoImpact",
						"DeprecatedRFIResponsePotentialImpact",
						"DeprecatedRFIResponseHasImpact",
						"DeprecatedRFIClose",
						"DeprecatedSubmittalClose",
						"UDACReceive",
						"UDACForward",
						"UDACRecordResponse",
						"UDACSend",
						"UDACClose",
						"UDACReopen",
						"UDACSendAndClose",
						"UDACRespondAndCloseNoActionTaken",
						"UDACRespondAndCloseApprove",
						"UDACRespondAndCloseRejected",
						"UDACRespondAndCloseResubmit",
						"UDACFinalReceive",
						"UDACCloseApprove",
						"UDACSendAndCloseApprove",
						"UDACCloseNoActionTaken",
						"UDACCloseRejected"
					],
					"type": "string"
				}
			}
		},
		"ViaDto": {
			"description": "This is the method that was used to send or receive the transmittal.",
			"required": [
				"type",
				"label"
			],
			"type": "object",
			"properties": {
				"type": {
					"description": "String of how the parent item was received.  This type is a keyword that\r\ncould be a value from the \"Global Physical Transfer Method List\"\r\nor the \"Define Send Via and Receive Via Values\" section within\r\nproject settings.",
					"enum": [
						"None",
						"Email",
						"InfoExchange",
						"DragDrop",
						"Physical",
						"ConnectorBluebeam",
						"NewformaApi"
					],
					"type": "string"
				},
				"label": {
					"description": "String of the name of the type.  This label is user defined.",
					"type": "string"
				},
				"url": {
					"description": "Source URL of the original item received or sent",
					"type": "string"
				}
			}
		},
		"RelatedFileDto": {
			"type": "object",
			"properties": {
				"relationshipType": {
					"enum": [
						"SupportingDocument",
						"SupportingEmail",
						"RecordCopyZip",
						"TransmittalPDF",
						"PreviousTransmittalPDF",
						"MarkupSource",
						"MarkupExternalFormat",
						"MarkupLink",
						"MasterZip",
						"KeywordAssignment",
						"BimSourceFile",
						"DataSheet",
						"RecordDocumentRevisionSource",
						"SketchSource",
						"PendingFolderUpdateZip",
						"Active",
						"Archive",
						"ContractFile",
						"ChangeOrderFile",
						"ManifestEntryMarkupSource",
						"MissingFileMarkupSource",
						"GeneratedFile",
						"ProjectFile"
					],
					"type": "string"
				},
				"file": {
					"$ref": "#/definitions/VersionedEdmsObjectIdDto"
				}
			}
		},
		"IssuedDocumentFilterRequestDto": {
			"type": "object",
			"properties": {
				"lastModifiedUtc": {
					"format": "date-time",
					"type": "string"
				},
				"contentFormatType": {
					"description": "This controls how the content of the Description field is returned.",
					"enum": [
						"Default",
						"HTML",
						"RTF",
						"Text"
					],
					"type": "string"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				}
			}
		},
		"FilterResponseDto[RecordDocumentDetailsDto]": {
			"type": "object",
			"properties": {
				"items": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RecordDocumentDetailsDto"
					}
				},
				"offsetToken": {
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"GenericFilterRequestDto": {
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"projectItemNumber": {
					"type": "string"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[WorkflowStatus]"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto"
				},
				"lastModifiedUtc": {
					"format": "date-time",
					"type": "string"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				}
			}
		},
		"KeywordDto[WorkflowStatus]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"closed",
						"draft",
						"expected",
						"open",
						"pending"
					],
					"type": "string"
				}
			}
		},
		"FilterResponseDto[RfiReferenceDto]": {
			"type": "object",
			"properties": {
				"items": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RfiReferenceDto"
					}
				},
				"offsetToken": {
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"RfiReferenceDto": {
			"required": [
				"id",
				"subject",
				"number"
			],
			"type": "object",
			"properties": {
				"transmittalIds": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"senderId": {
					"type": "string"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[WorkflowStatus]"
				},
				"id": {
					"format": "uuid",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"subject": {
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"relatedFiles": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RelatedFileDto"
					}
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto"
				},
				"relatedItems": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RelatedItemDto"
					}
				}
			}
		},
		"RelatedItemDto": {
			"type": "object",
			"properties": {
				"id": {
					"type": "string"
				},
				"relationshipType": {
					"type": "string"
				},
				"relatedItemType": {
					"type": "string"
				}
			}
		},
		"CreateRfiDto": {
			"required": [
				"rfiType",
				"status",
				"subject"
			],
			"type": "object",
			"properties": {
				"rfiType": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]",
					"description": "The RFI Type field is REQUIRED. Its value must exist in the UAC RFI types List"
				},
				"reasons": {
					"description": "The Reasons field is OPTIONAL",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"originatedBy": {
					"description": "The Originated field is OPTIONAL.  If specified it must be the valid GUID of a contact associated\r\nwith the project",
					"type": "string"
				},
				"discipline": {
					"description": "The Discipline field is OPTIONAL.  If specified the values must exist in the UAC Disciplines List\r\nor the project setting must be set to allow custom",
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"contract": {
					"description": "The Contract field is OPTIONAL.  If specified it must be the valid GUID of a contract associated\r\nwith the project",
					"type": "string"
				},
				"suggestion": {
					"description": "The Suggestion field is OPTIONAL.",
					"type": "string"
				},
				"senderId": {
					"type": "string"
				},
				"toContactIds": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"fromContactId": {
					"type": "string"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[WorkflowStatus]"
				},
				"action": {
					"$ref": "#/definitions/KeywordDto[WorkflowAction]"
				},
				"sourceUrl": {
					"type": "string"
				},
				"files": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RemoteFileDto"
					}
				},
				"subject": {
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"remarks": {
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto"
				}
			}
		},
		"KeywordDto[WorkflowAction]": {
			"required": [
				"name",
				"type"
			],
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"type": {
					"enum": [
						"close",
						"close_approve",
						"close_no_action_taken",
						"close_rejected",
						"final_receive",
						"forward",
						"receive",
						"record_response",
						"reopen",
						"respond_and_close_approve",
						"respond_and_close_no_action_taken",
						"respond_and_close_rejected",
						"respond_and_close_resubmit",
						"send",
						"send_and_close",
						"send_and_close_approve",
						"BasicTransmittalOutgoing"
					],
					"type": "string"
				}
			}
		},
		"RfiDto": {
			"required": [
				"id",
				"subject",
				"number"
			],
			"type": "object",
			"properties": {
				"toContactIds": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"fromContactId": {
					"type": "string"
				},
				"remarks": {
					"type": "string"
				},
				"transmittalIds": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"senderId": {
					"type": "string"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[WorkflowStatus]"
				},
				"id": {
					"format": "uuid",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"subject": {
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"relatedFiles": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RelatedFileDto"
					}
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto"
				},
				"relatedItems": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RelatedItemDto"
					}
				}
			}
		},
		"GenericReopenDto": {
			"required": [
				"contactId",
				"reason"
			],
			"type": "object",
			"properties": {
				"contactId": {
					"type": "string"
				},
				"reason": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"remarks": {
					"type": "string"
				}
			}
		},
		"GenericExternalWorkflowDto": {
			"required": [
				"event"
			],
			"type": "object",
			"properties": {
				"event": {
					"type": "string"
				},
				"message": {
					"type": "string"
				}
			}
		},
		"SearchRequestDto": {
			"type": "object",
			"properties": {
				"projects": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/SearchProjectDto"
					}
				},
				"requestedProperties": {
					"type": "array",
					"items": {
						"enum": [
							"cts_key",
							"file_key",
							"cross_reference",
							"reference",
							"entry_path",
							"filter_result",
							"filter_reason",
							"filter_time",
							"filter_timespan",
							"image_application_name",
							"image_author",
							"image_camera_manufacturer",
							"image_camera_model",
							"image_comment",
							"image_copyright",
							"image_date_taken",
							"image_format",
							"image_keywords",
							"image_location",
							"image_rating",
							"image_subject",
							"image_title",
							"image_pixel_dimensions",
							"image_bits_per_pixel",
							"edms_plugin_config_id",
							"edms_provider_id",
							"file_directory",
							"file_name",
							"file_path",
							"file_size",
							"file_system_attributes",
							"file_write_time",
							"file_create_time",
							"file_content"
						],
						"type": "string"
					}
				},
				"previewPrefix": {
					"type": "string"
				},
				"previewSuffix": {
					"type": "string"
				},
				"resultsLimitType": {
					"enum": [
						"default",
						"none",
						"user_specified"
					],
					"type": "string"
				},
				"resultsLimit": {
					"format": "int32",
					"type": "integer"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				},
				"contentPhrase": {
					"type": "string"
				},
				"fileNamePhrase": {
					"type": "string"
				}
			}
		},
		"SearchProjectDto": {
			"type": "object",
			"properties": {
				"id": {
					"type": "string"
				},
				"folders": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/EdmsObjectIdDto"
					}
				}
			}
		},
		"PagedResponseDto[SearchResponseDto]": {
			"type": "object",
			"properties": {
				"items": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/SearchResponseDto"
					}
				},
				"offsetToken": {
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"SearchResponseDto": {
			"type": "object",
			"properties": {
				"previews": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/PropertyPreviewPair"
					}
				},
				"properties": {
					"type": "object",
					"properties": {
						"cts_key": {
							"type": "object"
						},
						"file_key": {
							"type": "object"
						},
						"cross_reference": {
							"type": "object"
						},
						"reference": {
							"type": "object"
						},
						"entry_path": {
							"type": "object"
						},
						"filter_result": {
							"type": "object"
						},
						"filter_reason": {
							"type": "object"
						},
						"filter_time": {
							"type": "object"
						},
						"filter_timespan": {
							"type": "object"
						},
						"image_application_name": {
							"type": "object"
						},
						"image_author": {
							"type": "object"
						},
						"image_camera_manufacturer": {
							"type": "object"
						},
						"image_camera_model": {
							"type": "object"
						},
						"image_comment": {
							"type": "object"
						},
						"image_copyright": {
							"type": "object"
						},
						"image_date_taken": {
							"type": "object"
						},
						"image_format": {
							"type": "object"
						},
						"image_keywords": {
							"type": "object"
						},
						"image_location": {
							"type": "object"
						},
						"image_rating": {
							"type": "object"
						},
						"image_subject": {
							"type": "object"
						},
						"image_title": {
							"type": "object"
						},
						"image_pixel_dimensions": {
							"type": "object"
						},
						"image_bits_per_pixel": {
							"type": "object"
						},
						"edms_plugin_config_id": {
							"type": "object"
						},
						"edms_provider_id": {
							"type": "object"
						},
						"file_directory": {
							"type": "object"
						},
						"file_name": {
							"type": "object"
						},
						"file_path": {
							"type": "object"
						},
						"file_size": {
							"type": "object"
						},
						"file_system_attributes": {
							"type": "object"
						},
						"file_write_time": {
							"type": "object"
						},
						"file_create_time": {
							"type": "object"
						},
						"file_content": {
							"type": "object"
						}
					}
				}
			}
		},
		"PropertyPreviewPair": {
			"type": "object",
			"properties": {
				"property": {
					"enum": [
						"cts_key",
						"file_key",
						"cross_reference",
						"reference",
						"entry_path",
						"filter_result",
						"filter_reason",
						"filter_time",
						"filter_timespan",
						"image_application_name",
						"image_author",
						"image_camera_manufacturer",
						"image_camera_model",
						"image_comment",
						"image_copyright",
						"image_date_taken",
						"image_format",
						"image_keywords",
						"image_location",
						"image_rating",
						"image_subject",
						"image_title",
						"image_pixel_dimensions",
						"image_bits_per_pixel",
						"edms_plugin_config_id",
						"edms_provider_id",
						"file_directory",
						"file_name",
						"file_path",
						"file_size",
						"file_system_attributes",
						"file_write_time",
						"file_create_time",
						"file_content"
					],
					"type": "string"
				},
				"preview": {
					"type": "string"
				}
			}
		},
		"CreateSpaceDto": {
			"type": "object",
			"properties": {
				"source": {
					"$ref": "#/definitions/SourceInfoDto"
				},
				"name": {
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"description": {
					"type": "string"
				},
				"keywords": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				}
			}
		},
		"SpaceFilterRequestDto": {
			"type": "object",
			"properties": {
				"spaceId": {
					"type": "string"
				},
				"name": {
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				},
				"isDataFilter": {
					"type": "boolean",
					"readOnly": true
				}
			}
		},
		"FilterResponseDto[SpaceItemDto]": {
			"type": "object",
			"properties": {
				"items": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/SpaceItemDto"
					}
				},
				"offsetToken": {
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"SpaceItemDto": {
			"type": "object",
			"properties": {
				"projectId": {
					"type": "string"
				},
				"spaceId": {
					"type": "string"
				},
				"name": {
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"lastModifiedDateUTC": {
					"type": "string"
				},
				"description": {
					"type": "string"
				},
				"keywords": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto"
				}
			}
		},
		"ModifySpaceDto": {
			"type": "object",
			"properties": {
				"name": {
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"description": {
					"type": "string"
				},
				"keywords": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/KeywordDto[GenericKeyword]"
					}
				}
			}
		},
		"ForbiddenException": {
			"type": "object",
			"properties": {
				"message": {
					"type": "string",
					"readOnly": true
				},
				"data": {
					"type": "object",
					"additionalProperties": {
						"type": "object"
					},
					"readOnly": true
				},
				"innerException": {
					"type": "object",
					"readOnly": true
				},
				"stackTrace": {
					"type": "string",
					"readOnly": true
				},
				"helpLink": {
					"type": "string"
				},
				"source": {
					"type": "string"
				},
				"hResult": {
					"format": "int32",
					"type": "integer",
					"readOnly": true
				}
			}
		},
		"FilterResponseDto[SubmittalReferenceDto]": {
			"type": "object",
			"properties": {
				"items": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/SubmittalReferenceDto"
					}
				},
				"offsetToken": {
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"SubmittalReferenceDto": {
			"required": [
				"id",
				"subject",
				"number"
			],
			"type": "object",
			"properties": {
				"transmittalIds": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"senderId": {
					"type": "string"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[WorkflowStatus]"
				},
				"id": {
					"format": "uuid",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"subject": {
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"relatedFiles": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RelatedFileDto"
					}
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto"
				},
				"relatedItems": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RelatedItemDto"
					}
				}
			}
		},
		"CreateSubmittalDto": {
			"required": [
				"status",
				"subject"
			],
			"type": "object",
			"properties": {
				"expectedDate": {
					"format": "date",
					"type": "string"
				},
				"specSection": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"senderId": {
					"type": "string"
				},
				"toContactIds": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"fromContactId": {
					"type": "string"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[WorkflowStatus]"
				},
				"action": {
					"$ref": "#/definitions/KeywordDto[WorkflowAction]"
				},
				"sourceUrl": {
					"type": "string"
				},
				"files": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RemoteFileDto"
					}
				},
				"subject": {
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"remarks": {
					"type": "string"
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto"
				}
			}
		},
		"SubmittalDto": {
			"required": [
				"id",
				"subject",
				"number"
			],
			"type": "object",
			"properties": {
				"expectedDate": {
					"format": "date",
					"type": "string"
				},
				"specSection": {
					"$ref": "#/definitions/KeywordDto[GenericKeyword]"
				},
				"toContactIds": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"fromContactId": {
					"type": "string"
				},
				"remarks": {
					"type": "string"
				},
				"transmittalIds": {
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"senderId": {
					"type": "string"
				},
				"status": {
					"$ref": "#/definitions/KeywordDto[WorkflowStatus]"
				},
				"id": {
					"format": "uuid",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"subject": {
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"relatedFiles": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RelatedFileDto"
					}
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto"
				},
				"relatedItems": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RelatedItemDto"
					}
				}
			}
		},
		"TransmittalDetailsDto": {
			"required": [
				"action",
				"creationDate",
				"fromContactId",
				"toContactIds",
				"dueDate",
				"via",
				"id",
				"subject",
				"number"
			],
			"type": "object",
			"properties": {
				"action": {
					"$ref": "#/definitions/KeywordDto[DBTransmittalActionType]",
					"description": "The specific information about the transmittal being returned"
				},
				"creationDate": {
					"format": "date",
					"description": "Transmittal date, no time included",
					"type": "string"
				},
				"fromContactId": {
					"description": "The from contact that originated the related project item.",
					"type": "string"
				},
				"toContactIds": {
					"description": "A list of the contact IDs of the recipient.",
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"dueDate": {
					"format": "date",
					"description": "The due date, no time included",
					"type": "string"
				},
				"via": {
					"$ref": "#/definitions/ViaDto",
					"description": "The via object describes how the transmittal was sent or received."
				},
				"remarks": {
					"type": "string"
				},
				"id": {
					"format": "uuid",
					"type": "string",
					"example": "00000000-0000-0000-0000-000000000000"
				},
				"subject": {
					"type": "string"
				},
				"number": {
					"type": "string"
				},
				"relatedFiles": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RelatedFileDto"
					}
				},
				"source": {
					"$ref": "#/definitions/SourceInfoDto"
				},
				"relatedItems": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/RelatedItemDto"
					}
				}
			}
		},
		"TransmittalFilterRequestDto": {
			"type": "object",
			"properties": {
				"relatedItemTypeFilter": {
					"enum": [
						"ProjectItemToIssue"
					],
					"type": "string"
				},
				"lastModifiedUtc": {
					"format": "date-time",
					"type": "string"
				},
				"paging": {
					"$ref": "#/definitions/PagingRequest"
				}
			}
		},
		"FilterResponseDto[TransmittalDetailsDto]": {
			"type": "object",
			"properties": {
				"items": {
					"type": "array",
					"items": {
						"$ref": "#/definitions/TransmittalDetailsDto"
					}
				},
				"offsetToken": {
					"type": "string"
				},
				"remainingItems": {
					"format": "int32",
					"type": "integer"
				}
			}
		},
		"Contact": {
			"description": "Contact information",
			"type": "object",
			"properties": {
				"id": {
					"description": "Unique ID (Guid) of the contact",
					"type": "string"
				},
				"emailAddress": {
					"description": "Email address",
					"type": "string"
				},
				"firstName": {
					"description": "First name, which may be given name or family name",
					"type": "string"
				},
				"lastName": {
					"description": "Last name, which may be given name or family name",
					"type": "string"
				},
				"phoneNumber": {
					"description": "Phone number",
					"type": "string"
				},
				"companyName": {
					"description": "Company name",
					"type": "string"
				}
			}
		},
		"NewformaVersionInfo": {
			"type": "object",
			"properties": {
				"newformaApiVersion": {
					"type": "string"
				},
				"newformaApiCompatibilityNumber": {
					"type": "string"
				},
				"npcsVersion": {
					"type": "string"
				},
				"npcsCompatibilityNumber": {
					"type": "string"
				},
				"coreVersion": {
					"type": "string"
				},
				"apiVersion": {
					"type": "string"
				},
				"customerId": {
					"type": "string"
				},
				"machineName": {
					"type": "string"
				},
				"enterpriseApisEnabled": {
					"type": "string"
				}
			}
		},
		"ModifyPunchListItemDtoExample": {
			"type": "object",
			"properties": {
				"spaceId": {
					"default": "00000000-0000-0000-0000-000000000000",
					"type": "string"
				},
				"id": {
					"default": "0001",
					"type": "string"
				},
				"type": {
					"default": {
						"name": "Punch List",
						"type": "generic"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"location": {
					"default": {
						"name": "Heather Ripley, Ripley PR, 865-977-1973",
						"type": "generic"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"element": {
					"default": {
						"name": "desk office",
						"type": "generic"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"description": {
					"default": {
						"name": "pipe is leaking",
						"type": "generic"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"assignedTo": {
					"default": [
						"00000000-0000-0000-0000-000000000000",
						"00000000-0000-0000-0000-000000000000"
					],
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"capturedBy": {
					"default": "00000000-0000-0000-0000-000000000000",
					"type": "string"
				},
				"members": {
					"default": [
						"00000000-0000-0000-0000-000000000000",
						"00000000-0000-0000-0000-000000000000"
					],
					"type": "array",
					"items": {
						"type": "string"
					}
				},
				"dueDate": {
					"default": "1989-11-25T07:53:00.123Z",
					"type": "string"
				},
				"date": {
					"default": "1989-11-25T07:53:00.123Z",
					"type": "string"
				},
				"specSection": {
					"default": {
						"name": "01 01 1001",
						"type": "generic"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"discipline": {
					"default": {
						"name": "Plumbing",
						"type": "generic"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"purpose": {
					"default": {
						"name": "because its broken",
						"type": "generic"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"status": {
					"default": {
						"name": "Open",
						"type": "Open"
					},
					"type": "KeywordDto[GenericKeyword]"
				},
				"keywords": {
					"type": "array",
					"items": {
						"default": {
							"name": "I need new pipe",
							"type": "generic"
						},
						"type": "KeywordDto[GenericKeyword]"
					}
				},
				"remarks": {
					"default": "there was a pipe that broke",
					"type": "string"
				}
			}
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/Reference/NewformaAPI040323.json
 ** module id = 1385
 ** module chunks = 0
 **/